/* Gloramous — Laboratoires Dr. Elias Saab
   Progressive enhancement only. Every page works with this file absent.
   Motion is gated on prefers-reduced-motion throughout; the CSS already
   treats the still page as the default. */
(function () {
  'use strict';

  /* ── stay in the visitor's language ────────────────────────────────────
     Arabic is the store default, so English lives under /en/. Links written
     as "/pages/quiz" in templates and settings opened the Arabic page. Give
     every internal link (and form) the language prefix, including ones the
     scripts add later (fixed at click time). */
  var LROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Saved, recently viewed and compare remember products from either language.
     When drawn, each link is rebuilt for this page's language and the name is
     fetched in it if it was stored in the other one. */
  var LANG_NOW = (document.documentElement.lang || '').split('-')[0];
  var nameCache = {};
  window.GloramousLocalise = function (scope) {
    (scope || document).querySelectorAll('[data-l10n-handle]').forEach(function (el) {
      var h = el.getAttribute('data-l10n-handle');
      if (!h) return;
      if (el.tagName === 'A') el.setAttribute('href', LROOT + 'products/' + h);
      var nameEl = el.querySelector('[data-l10n-name]');
      if (!nameEl || el.getAttribute('data-l10n-lang') === LANG_NOW) return;
      if (!nameCache[h]) nameCache[h] = fetch(LROOT + 'products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.title; })
        .catch(function () { return null; });
      nameCache[h].then(function (t) { if (t) nameEl.textContent = t; });
    });
  };
  if (LROOT !== '/') {
    var LPRE = LROOT.replace(/\/$/, '');
    var SKIP = /^\/(cdn|checkouts?|account|services|apps|tools|wpm|s\/|cart\/[0-9])/;
    var localise = function (el, attr) {
      var h = el.getAttribute(attr);
      if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/') return;
      if (h === LPRE || h.indexOf(LROOT) === 0 || h.indexOf(LPRE + '?') === 0 || h.indexOf(LPRE + '#') === 0 || SKIP.test(h)) return;
      el.setAttribute(attr, LPRE + h);
    };
    document.querySelectorAll('a[href^="/"]').forEach(function (a) { localise(a, 'href'); });
    document.querySelectorAll('form[action^="/"]').forEach(function (f) { localise(f, 'action'); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="/"]');
      if (a) localise(a, 'href');
    }, true);
    document.addEventListener('submit', function (e) {
      if (e.target.matches && e.target.matches('form[action^="/"]')) localise(e.target, 'action');
    }, true);
  }

  var motionOK = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

  /* ── header condenses once you leave the top ──────────────────────── */
  var head = document.querySelector('.site-head');
  if (head) {
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    document.body.prepend(sentinel);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        head.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }).observe(sentinel);
    }

    /* ── the header's real height, published ──────────────────────────────
       Every sticky bar under the header was offset by a hardcoded `top:94px`
       with a `top:0` override below 860px. Measured at 375x812 that put the
       catalogue's filter disclosure entirely behind the 68px header -- 0px of
       a 44px control reachable -- and the ingredients search field at 6.5px.
       A guessed constant cannot survive a breakpoint, so the header measures
       itself and the bars read it. */
    var setHeadH = function () {
      var h = Math.round(head.getBoundingClientRect().height);
      if (h) document.documentElement.style.setProperty('--head-h', h + 'px');
    };
    setHeadH();
    if ('ResizeObserver' in window) new ResizeObserver(setHeadH).observe(head);
    else window.addEventListener('resize', setHeadH);

    /* ── on a phone the header steps out of the way going down ───────────
       68px of a 812px viewport is 8% of the screen held permanently by a
       logo you have already read. It returns the instant you scroll up, which
       is when you want to reach navigation, and it never leaves while a sheet
       is open or while focus is inside it. */
    (function () {
      var away = false, last = window.scrollY, acc = 0;
      var TH = 9;                       // travel needed to commit, both ways
      function set(v) {
        if (v === away) return;
        away = v;
        head.classList.toggle('is-away', v);
        document.documentElement.classList.toggle('head-away', v);
      }
      /* No requestAnimationFrame around this. It reads window.scrollY and two
         class lists -- nothing that forces layout -- and scroll already fires
         at most once per frame, so the rAF was coalescing something that could
         not arrive twice. It also made the whole feature untestable in any
         environment whose rendering loop is stalled. */
      function frame() {
        /* 2026-09-17: the header now stays on the phone too. It carries the
           search bar, and shoppers asked for it to follow them down the page. */
        if (!head.hasAttribute('data-head-hides') || window.innerWidth >= 720) { set(false); return; }
        if (document.documentElement.classList.contains('is-locked')) return;
        var y = window.scrollY, dy = y - last;
        last = y;
        if (Math.abs(dy) < 2) return;
        /* accumulate in the current direction and reset on reversal, so a
           1px tremor cannot flip a 68px bar, and a deliberate 9px of travel
           always does */
        acc = (dy > 0) === (acc > 0) ? acc + dy : dy;
        if (y < 110 || head.contains(document.activeElement)) { set(false); return; }
        if (acc > TH) set(true);
        else if (acc < -TH) set(false);
      }
      window.addEventListener('scroll', frame, { passive: true });
      window.addEventListener('resize', frame);
      head.__glamHeadAway = frame;      // so the state can be driven in a test
    })();
  }

  /* ── scroll progress, for browsers without animation-timeline ─────── */
  var bar = document.querySelector('.progress-top');
  if (bar && motionOK && !CSS.supports('animation-timeline', 'scroll(root)')) {
    var tick = function () {
      var d = document.documentElement;
      var max = d.scrollHeight - d.clientHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? d.scrollTop / max : 0) + ')';
    };
    addEventListener('scroll', tick, { passive: true });
    tick();
  }

  /* ── figures count up once, when they arrive ──────────────────────── */
  if (motionOK && 'IntersectionObserver' in window) {
    var nums = document.querySelectorAll('[data-count]');
    if (nums.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var el = e.target;
          var raw = el.getAttribute('data-count');
          var target = parseInt(raw, 10);
          if (isNaN(target)) return;
          var suffix = raw.replace(/[0-9]/g, '');
          var settle = function () { el.textContent = target + suffix; };

          // requestAnimationFrame is throttled while the tab is hidden, which
          // strands the number partway — 337 instead of 2005. Never animate
          // into a wrong value: skip it when hidden, and force the final value
          // on a timer regardless of whether the frames arrived.
          if (document.hidden) { settle(); return; }

          var dur = 900;
          var t0 = performance.now();
          var guard = setTimeout(settle, dur + 250);
          var step = function (now) {
            var p = Math.min(1, (now - t0) / dur);
            el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
            if (p < 1) {
              requestAnimationFrame(step);
            } else {
              clearTimeout(guard);
              settle();
            }
          };
          requestAnimationFrame(step);
        });
      }, { threshold: 0.4 });
      nums.forEach(function (n) { io.observe(n); });
    }
  }

  /* ── hero: the photograph no longer slides with the pointer ─────────
     Removed in the calm round. The pointer still moves the light across it
     (the lamp, further down), which changes brightness, not position. */

  /* ── product gallery ──────────────────────────────────────────────── */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gallery-thumb]');
      if (!btn || !main) return;
      main.src = btn.getAttribute('data-src');
      main.removeAttribute('srcset');
      if (btn.hasAttribute('data-zoom')) main.setAttribute('data-zoom', btn.getAttribute('data-zoom'));
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', String(b === btn));
      });
    });
  }

  /* ── zoom: the product picture opens large in a native <dialog> (focus, Escape and
     screen readers come with it); a tap anywhere or the button closes it. A fade only. ── */
  (function () {
    var main = document.querySelector('[data-gallery-main]');
    if (!main || typeof HTMLDialogElement === 'undefined') return;
    // only pictures the server marked as big enough (see data-zoomable in main-product.liquid)
    if (!main.hasAttribute('data-zoomable')) return;
    main.classList.add('is-zoomable');
    main.setAttribute('tabindex', '0');
    main.setAttribute('role', 'button');
    main.setAttribute('aria-label', 'Show a larger picture');
    function open() {
      var dlg = document.createElement('dialog');
      dlg.className = 'zoom';
      dlg.setAttribute('aria-label', main.getAttribute('alt') || 'Product picture');
      dlg.innerHTML = '<img alt="">' + '<button class="zoom-x" type="button" aria-label="Close">&times;</button>';
      var zimg = dlg.querySelector('img'), big = main.getAttribute('data-zoom');
      zimg.src = main.currentSrc || main.src;
      if (big && big !== zimg.src) { var pre = new Image(); pre.onload = function () { zimg.src = big; }; pre.src = big; }
      dlg.querySelector('img').alt = main.getAttribute('alt') || '';
      var gone = false;
      function tidy() {                    // safe to call twice: from a tap and from the close event
        if (gone) return;
        gone = true;
        document.documentElement.classList.remove('is-zoomed');
        dlg.classList.remove('is-on');
        setTimeout(function () { dlg.remove(); }, 200);
      }
      dlg.addEventListener('click', function () { if (dlg.open) dlg.close(); tidy(); });
      dlg.addEventListener('close', tidy);   // Escape closes a modal dialog natively
      document.body.appendChild(dlg);
      dlg.showModal();
      document.documentElement.classList.add('is-zoomed');
      void dlg.offsetHeight;
      dlg.classList.add('is-on');
    }
    main.addEventListener('click', open);
    main.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  })();

  /* ── variant buttons drive the hidden id, so the form still posts ─── */
  var opts = document.querySelector('[data-opts]');
  if (opts) {
    var idField = document.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('[data-variant-price]');
    var bbPrice = document.querySelector('[data-bb-price]');
    opts.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-vid]');
      if (!b) return;
      opts.querySelectorAll('button[data-vid]').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      if (idField) idField.value = b.getAttribute('data-vid');
      var html = b.getAttribute('data-price-html');
      // the price rolls to its new value (GloramousRoll is defined at the end
      // of this file, and the listener only runs on a click, long after)
      var setP = window.GloramousRoll || function (el, h) { el.innerHTML = h; };
      if (priceEl && html) setP(priceEl, html);
      if (bbPrice && html) setP(bbPrice, html);

      // a variant with its own picture shows it, and the matching thumbnail lights up
      var vimg = b.getAttribute('data-img');
      var gmain = document.querySelector('[data-gallery-main]');
      if (vimg && gmain) {
        gmain.src = vimg;
        gmain.removeAttribute('srcset');
        if (b.hasAttribute('data-zoom')) gmain.setAttribute('data-zoom', b.getAttribute('data-zoom'));
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', String(t.getAttribute('data-src') === vimg));
        });
      }

      // the size and the price per 100 mL follow the selection too, or a 500 mL
      // choice sits under a "280 mL" subtitle quoting the 280 mL unit price
      var size = b.getAttribute('data-size');
      if (size) {
        document.querySelectorAll('[data-variant-size]').forEach(function (el) {
          el.textContent = size;
        });
      }
      if (b.hasAttribute('data-unit-html')) {
        var unit = b.getAttribute('data-unit-html');
        document.querySelectorAll('[data-unit-price]').forEach(function (el) {
          el.innerHTML = unit;
          el.hidden = !unit;
        });
        var bare = b.getAttribute('data-unit-bare-html') || '';
        document.querySelectorAll('[data-unit-bare]').forEach(function (el) {
          el.innerHTML = bare;
          var row = el.parentElement;
          if (row) row.hidden = !bare;
        });
      }

      // the address bar carries the size, so a reload, a shared link or the
      // language switch keep it
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', b.getAttribute('data-vid'));
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      } catch (err) {}

      // "Pairs well with": this product's line in "Add all three" is the chosen size
      var tog = document.querySelector('.together [data-add-lines]');
      var cents = parseInt(b.getAttribute('data-price-cents') || '', 10);
      if (tog && !isNaN(cents)) {
        try {
          var lines = JSON.parse(tog.getAttribute('data-add-lines'));
          var old = lines[0].price;
          lines[0].id = parseInt(b.getAttribute('data-vid'), 10);
          lines[0].price = cents;
          lines[0].variant = (size || '').split(' / ').pop();
          tog.setAttribute('data-add-lines', JSON.stringify(lines));
          var fmt = function (c) { return '$' + (c / 100).toFixed(2); };
          var mine = document.querySelector('.together .together-item.is-this .together-price');
          if (mine) mine.textContent = fmt(cents);
          var tot = document.querySelector('.together .together-total b');
          if (tot) tot.textContent = fmt(lines.reduce(function (s, l) { return s + (l.price || 0); }, 0));
          void old;
        } catch (err) {}
      }
    });
  }

  /* ── quantity stepper ─────────────────────────────────────────────── */
  document.querySelectorAll('[data-stepper]').forEach(function (st) {
    var input = st.querySelector('input');
    st.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-step]');
      if (!b || !input) return;
      var next = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10);
      input.value = Math.max(parseInt(input.min || '1', 10), next);
      // in the cart the quantity field drives a form submit, so tell it
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ── the mobile buy bar submits the real product form ─────────────── */
  /* ── desktop: the buy bar arrives once the real button has scrolled away ──
     On phones the bar is always there. On a desktop product page the buy box
     is sticky beside the gallery, but the ingredients, the accordions and the
     acid table run well below it, and a reader down there had no way to buy
     without scrolling back. The bar slides in when the buy box is above the
     viewport and leaves as soon as it is back in view. */
  var bbBar = document.querySelector('[data-buybar]');
  // <main> is its own layer (body > * z-index:1), so the footer painted over a bar
  // fixed inside it and took the taps meant for Add to cart. Lift the bar out.
  if (bbBar) document.body.appendChild(bbBar);
  var bbBox = document.querySelector('.buybox');
  if (bbBar && bbBox && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var above = !e.isIntersecting && e.boundingClientRect.top < 0;
      bbBar.classList.toggle('is-shown', above);
    }, { threshold: 0 }).observe(bbBox);
  }

  var bb = document.querySelector('[data-buybar-submit]');
  if (bb) {
    document.body.classList.add('has-buybar');
    bb.addEventListener('click', function () {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ── the register, where it is still used ─────────────────────────── */
  var register = document.querySelector('[data-register]');
  if (register) {
    var rows = Array.prototype.slice.call(register.querySelectorAll('.row'));
    var chips = Array.prototype.slice.call(register.querySelectorAll('.chip'));
    var search = register.querySelector('[data-register-search]');
    var count = register.querySelector('[data-register-count]');
    var empty = register.querySelector('[data-register-empty]');
    var total = rows.length, filter = 'all', query = '';

    var apply = function () {
      var shown = 0;
      rows.forEach(function (row) {
        var okQ = !query || (row.getAttribute('data-search') || '').indexOf(query) !== -1;
        var okF = filter === 'all' ||
          (' ' + (row.getAttribute('data-facets') || '') + ' ').indexOf(' ' + filter + ' ') !== -1;
        row.hidden = !(okQ && okF);
        if (okQ && okF) shown++;
      });
      if (count) count.innerHTML = '<b>' + shown + '</b> of ' + total + ' formulations';
      if (empty) empty.hidden = shown !== 0;
    };

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', String(c === chip)); });
        filter = chip.getAttribute('data-filter') || 'all';
        apply();
      });
    });
    if (search) {
      search.addEventListener('input', function (e) {
        query = e.target.value.trim().toLowerCase();
        apply();
      });
    }
    apply();
  }


  /* ── the catalogue ─────────────────────────────────────────────────
     Filters across three groups plus a price band, search, sort, and URL
     state. Scoped in an IIFE because `var` is function-wide and the register
     block above closes over identically named bindings.

     URL state matters: without it a filtered catalogue cannot be shared,
     bookmarked, or returned to with the back button. */
  (function () {
    var cat = document.querySelector('[data-catalogue]');
    if (!cat) return;

    var grid = cat.querySelector('[data-cat-grid]');
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.card'));
    var order = cards.slice();                   // original order, for "Featured"
    /* `:not([data-band])` -- the price chips sit inside a .cat-chips row too,
       and without this they were also wired as group chips: clicking
       "$20 to $40" ran `active[null].push(...)` and threw on every press. */
    var chips = Array.prototype.slice.call(cat.querySelectorAll('.cat-chips .chip:not([data-band])'));
    var priceChips = Array.prototype.slice.call(cat.querySelectorAll('[data-band]'));
    var search = cat.querySelector('[data-cat-search]');
    var sort = cat.querySelector('[data-cat-sort]');
    var clear = cat.querySelector('[data-cat-clear]');
    var countEl = cat.querySelector('[data-cat-count]');
    var emptyEl = cat.querySelector('[data-cat-empty]');

    var total = cards.length;
    // The collection calls them formulations, the catalogue calls them
    // products. Without this the controller overwrote the section's own word.
    var noun = cat.getAttribute('data-count-noun') || 'product';
    var active = { cat: [], concern: [], form: [] };
    var query = '';
    var band = '';                               // '', 'u20', '20-40', 'o40'

    function inBandOf(b, cents) {
      if (!b) return true;
      if (!cents) return false;                  // unpriced matches no band
      if (b === 'u20') return cents < 2000;
      if (b === '20-40') return cents >= 2000 && cents <= 4000;
      if (b === 'o40') return cents > 4000;
      return true;
    }

    /* `act` and `bnd` default to the live state, so matches(card) still means
       what it used to. Passing them explicitly is how the facet counts ask
       "what WOULD this give me" without mutating anything. */
    function matchesWith(card, act, bnd) {
      if (query) {
        // each word of the query has to match ("snail serum" = snail AND serum);
        // Arabic vowel marks, the stretch line and hamza forms don't matter
        var an = window.GloramousNorm || function (s) { return String(s || '').toLowerCase(); };
        var hay = an(card.getAttribute('data-search') || '');
        var words = an(query).split(' ').filter(function (w) { return w.length > 1; });
        if (!words.length) words = [an(query)];
        var all = words.every(function (w) {
          var terms = window.GloramousSearchTerms ? window.GloramousSearchTerms(w) : [w];
          return terms.concat([w]).some(function (q) { return hay.indexOf(an(q)) > -1; });
        });
        if (!all) return false;
      }
      if (!inBandOf(bnd, parseInt(card.getAttribute('data-price') || '0', 10))) return false;
      var f = ' ' + (card.getAttribute('data-facets') || '') + ' ';
      // AND across groups, OR within a group
      for (var g in act) {
        var vals = act[g];
        if (!vals.length) continue;
        var hit = false;
        for (var i = 0; i < vals.length; i++) {
          if (f.indexOf(' ' + vals[i] + ' ') !== -1) { hit = true; break; }
        }
        if (!hit) return false;
      }
      return true;
    }

    function matches(card) { return matchesWith(card, active, band); }

    /* How many products this facet would give you. The chip's own group is
       left out of the hypothesis: within a group the chips are ORed, so a
       count that shrank when you added a second chip to the same group would
       be lying about the direction of the change. */
    function countFor(group, value, bandOverride) {
      var act = {}, g;
      for (g in active) act[g] = (g === group) ? [] : active[g];
      if (group) act[group] = [value];
      var bnd = (group === null) ? bandOverride : band;
      var n = 0;
      for (var i = 0; i < cards.length; i++) {
        if (matchesWith(cards[i], act, bnd)) n++;
      }
      return n;
    }

    /* Write the counts onto the chips, and take the dead ones out of reach.
       A pressed chip is never disabled however small its count -- there has to
       be a way back out of a choice you already made. */
    function paintCounts() {
      chips.forEach(function (c) {
        var n = countFor(c.getAttribute('data-group'), c.getAttribute('data-value'));
        var pressed = c.getAttribute('aria-pressed') === 'true';
        var slot = c.querySelector('.chip-n');
        if (!slot) {
          slot = document.createElement('span');
          slot.className = 'chip-n';
          slot.setAttribute('aria-hidden', 'true');
          c.appendChild(slot);
        }
        slot.textContent = n;
        var dead = n === 0 && !pressed;
        c.disabled = dead;
        c.setAttribute('aria-disabled', String(dead));
      });
      priceChips.forEach(function (c) {
        var b = c.getAttribute('data-band');
        var n = countFor(null, null, b);
        var pressed = c.getAttribute('aria-pressed') === 'true';
        var slot = c.querySelector('.chip-n');
        if (!slot) {
          slot = document.createElement('span');
          slot.className = 'chip-n';
          slot.setAttribute('aria-hidden', 'true');
          c.appendChild(slot);
        }
        slot.textContent = n;
        var dead = n === 0 && !pressed;
        c.disabled = dead;
        c.setAttribute('aria-disabled', String(dead));
      });
    }

    function readUrl() {
      var q = new URLSearchParams(location.search);
      ['cat', 'concern', 'form'].forEach(function (g) {
        var v = q.get(g);
        active[g] = v ? v.split(',').filter(Boolean) : [];
      });
      query = (q.get('q') || '').trim().toLowerCase();
      band = q.get('price') || '';
      if (search) search.value = q.get('q') || '';
      if (sort) sort.value = q.get('sort') || 'featured';
      chips.forEach(function (c) {
        var g = c.getAttribute('data-group');
        c.setAttribute('aria-pressed',
          String((active[g] || []).indexOf(c.getAttribute('data-value')) !== -1));
      });
      priceChips.forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.getAttribute('data-band') === band));
      });
    }

    function writeUrl() {
      var q = new URLSearchParams();
      ['cat', 'concern', 'form'].forEach(function (g) {
        if (active[g].length) q.set(g, active[g].join(','));
      });
      if (query) q.set('q', query);
      if (band) q.set('price', band);
      if (sort && sort.value && sort.value !== 'featured') q.set('sort', sort.value);
      var qs = q.toString();
      history.replaceState(null, '', qs ? location.pathname + '?' + qs : location.pathname);
    }

    /* `animate` is passed only by deliberate toggles -- a chip, a price band, a
       pill, the sort, the clear button. Typing does NOT pass it: apply() runs
       per keystroke and a view transition per character would queue up and
       make the search feel like treacle.

       The mutation is one closure, called either directly or through the
       transition, so the no-transition path is the same code and not a second
       copy of it. */
    function apply(animate) {
      if (animate &&
          typeof document.startViewTransition === 'function' &&
          window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        var vt = document.startViewTransition(function () { applyNow(); });
        /* A second chip pressed before the first transition finishes skips the
           first one, which REJECTS its promises -- and nothing was listening, so
           every quick double-press logged an unhandled rejection. The filter
           itself still applied; only the error was wrong. */
        ['ready', 'finished', 'updateCallbackDone'].forEach(function (k) {
          if (vt && vt[k] && vt[k].catch) vt[k].catch(function () {});
        });
        return;
      }
      applyNow();
    }

    function applyNow() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = matches(c);
        c.hidden = !ok;
        if (ok) shown++;
      });

      var mode = sort ? sort.value : 'featured';
      var list = order.slice();
      if (mode === 'az' || mode === 'za') {
        list.sort(function (a, b) {
          var r = (a.getAttribute('data-title') || '')
            .localeCompare(b.getAttribute('data-title') || '');
          return mode === 'az' ? r : -r;
        });
      } else if (mode === 'value') {
        // price per 100 mL, so a 5 mL ampoule and a 1 litre bottle can be
        // compared. Cards without a parseable size sort last rather than
        // pretending to be the best value on the page.
        list.sort(function (a, b) {
          var ua = parseInt(a.getAttribute('data-unit') || '0', 10);
          var ub = parseInt(b.getAttribute('data-unit') || '0', 10);
          if (!ua && ub) return 1;
          if (ua && !ub) return -1;
          return ua - ub;
        });
      } else if (mode === 'low' || mode === 'high') {
        list.sort(function (a, b) {
          var pa = parseInt(a.getAttribute('data-price') || '0', 10);
          var pb = parseInt(b.getAttribute('data-price') || '0', 10);
          // unpriced products go last either way, never pretend to be free
          if (!pa && pb) return 1;
          if (pa && !pb) return -1;
          return mode === 'low' ? pa - pb : pb - pa;
        });
      }
      list.forEach(function (c) { grid.appendChild(c); });

      var on = query || band || active.cat.length || active.concern.length || active.form.length;
      paintActive(on);
      if (countEl) {
        var word = noun + (total === 1 ? '' : 's');
        countEl.innerHTML = on
          ? '<b>' + shown + '</b> of ' + total + ' ' + word
          : '<b>' + total + '</b> ' + word;
      }
      if (emptyEl) emptyEl.hidden = shown !== 0;
      if (clear) clear.hidden = !on;
      paintCounts();
      writeUrl();
    }

    /* ── the active filters, spelled out ─────────────────────────────────
       Labels are read off the chip that set each value, so the pill and the
       chip can never disagree. Removing a pill calls the same toggle the chip
       does — one code path, not two. */
    var activeHost = cat.querySelector('[data-cat-active]');
    var activePills = cat.querySelector('[data-cat-active-pills]');

    /* The chip's label was captured before any count was injected into it.
       Reading textContent now would give "Cream 17" and put the number in the
       pill as well. */
    chips.forEach(function (c) {
      if (!c.getAttribute('data-label')) {
        c.setAttribute('data-label', c.textContent.trim());
      }
    });
    priceChips.forEach(function (c) {
      if (!c.getAttribute('data-label')) {
        c.setAttribute('data-label', c.textContent.trim());
      }
    });

    function labelFor(group, value) {
      for (var i = 0; i < chips.length; i++) {
        if (chips[i].getAttribute('data-group') === group &&
            chips[i].getAttribute('data-value') === value) {
          return chips[i].getAttribute('data-label');
        }
      }
      return value;
    }

    function bandLabel(b) {
      for (var i = 0; i < priceChips.length; i++) {
        if (priceChips[i].getAttribute('data-band') === b) {
          return priceChips[i].getAttribute('data-label');
        }
      }
      return b;
    }

    /* Every value here can come from the address bar (?q=, ?cat=, ?concern=,
       ?form=, ?price=), so all of it is escaped before it becomes HTML: a
       crafted link must never be able to put markup or script on the page. */
    function escPill(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function paintActive(on) {
      if (!activeHost || !activePills) return;
      if (!on) { activeHost.hidden = true; activePills.innerHTML = ''; return; }
      var html = '';
      ['cat', 'concern', 'form'].forEach(function (g) {
        active[g].forEach(function (v) {
          html += '<button class="cat-pill" type="button" data-drop-group="' + g +
            '" data-drop-value="' + escPill(v) + '">' + escPill(labelFor(g, v)) +
            '<i aria-hidden="true">\u00d7</i>' +
            '<span class="sr">Remove this filter</span></button>';
        });
      });
      if (band) {
        html += '<button class="cat-pill" type="button" data-drop-band="' + escPill(band) +
          '">' + escPill(bandLabel(band)) + '<i aria-hidden="true">\u00d7</i>' +
          '<span class="sr">Remove this filter</span></button>';
      }
      if (query) {
        html += '<button class="cat-pill" type="button" data-drop-query="1">' +
          '\u201c' + escPill(query) + '\u201d<i aria-hidden="true">\u00d7</i>' +
          '<span class="sr">Clear the search</span></button>';
      }
      activePills.innerHTML = html;
      activeHost.hidden = false;
    }

    if (activePills) {
      activePills.addEventListener('click', function (e) {
        var p = e.target.closest ? e.target.closest('.cat-pill') : null;
        if (!p) return;
        var g = p.getAttribute('data-drop-group');
        if (g) {
          var v = p.getAttribute('data-drop-value');
          active[g] = active[g].filter(function (x) { return x !== v; });
          chips.forEach(function (c) {
            if (c.getAttribute('data-group') === g &&
                c.getAttribute('data-value') === v) {
              c.setAttribute('aria-pressed', 'false');
            }
          });
        } else if (p.getAttribute('data-drop-band')) {
          band = '';
          priceChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        } else if (p.getAttribute('data-drop-query')) {
          query = '';
          if (search) search.value = '';
        }
        apply(true);
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var g = chip.getAttribute('data-group');
        var v = chip.getAttribute('data-value');
        var was = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', String(!was));
        if (was) {
          active[g] = active[g].filter(function (x) { return x !== v; });
        } else {
          active[g].push(v);
        }
        apply(true);
      });
    });

    priceChips.forEach(function (c) {
      c.addEventListener('click', function () {
        var v = c.getAttribute('data-band');
        band = (band === v) ? '' : v;            // clicking the active band clears it
        priceChips.forEach(function (x) {
          x.setAttribute('aria-pressed', String(x.getAttribute('data-band') === band));
        });
        apply(true);
      });
    });

    if (search) {
      search.addEventListener('input', function (e) {
        query = e.target.value.trim().toLowerCase();
        apply();
      });
    }
    if (sort) sort.addEventListener('change', function () { apply(true); });
    if (clear) {
      clear.addEventListener('click', function () {
        active = { cat: [], concern: [], form: [] };
        query = '';
        band = '';
        if (search) search.value = '';
        if (sort) sort.value = 'featured';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        priceChips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        apply(true);
      });
    }

    readUrl();
    apply();
    addEventListener('popstate', function () { readUrl(); apply(); });
  })();

  /* ── the ingredient marquee: a visible pause (WCAG 2.2.2), since a finger
     has no hover to hold it still ───────────────────────────────────── */
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-marquee]').forEach(function (mq) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'motion-pause motion-pause--mq';
      b.setAttribute('aria-pressed', 'false');
      b.setAttribute('aria-label', 'Pause the moving strip');
      b.innerHTML = '<svg class="mp-pause" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg><svg class="mp-play" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5.2v13.6L19 12z"/></svg>';
      b.addEventListener('click', function () {
        var stop = !mq.classList.contains('is-paused');
        mq.classList.toggle('is-paused', stop);
        b.classList.toggle('is-stopped', stop);
        b.setAttribute('aria-pressed', stop ? 'true' : 'false');
        b.setAttribute('aria-label', stop ? 'Play the moving strip' : 'Pause the moving strip');
      });
      mq.appendChild(b);
    });
  })();

  /* ── glossary: filter the ingredient list as you type ─────────────── */
  (function () {
    var gl = document.querySelector('[data-gloss]');
    if (!gl) return;
    var items = Array.prototype.slice.call(gl.querySelectorAll('.gitem'));
    var input = document.querySelector('[data-gloss-search]');
    var count = document.querySelector('[data-gloss-count]');
    var empty = document.querySelector('[data-gloss-empty]');

    function apply() {
      var q = input ? input.value.trim().toLowerCase() : '';
      var shown = 0;
      items.forEach(function (it) {
        var ok = !q || (it.getAttribute('data-gloss-term') || '').indexOf(q) !== -1;
        it.hidden = !ok;
        if (ok) shown++;
      });
      if (count) {
        count.innerHTML = q
          ? '<b>' + shown + '</b> of ' + items.length + ' ingredients'
          : '<b>' + items.length + '</b> ingredients';
      }
      if (empty) empty.hidden = shown !== 0;
    }
    /* A letter heading with nothing under it is worse than no heading — the
       page fills with orphan letters as you type. Hide the group too. */
    function syncGroups() {
      document.querySelectorAll('[data-gloss-group]').forEach(function (g) {
        var any = g.querySelector('.gitem:not([hidden])');
        g.hidden = !any;
      });
    }
    if (input) input.addEventListener('input', function () { apply(); syncGroups(); });
    apply();
    syncGroups();
  })();

  /* ═══ announcement bar: closeable, and it comes back when reworded ═════
     The bar repeats on every page and after the third page it is furniture.
     Liquid stamps an md5 of the two messages onto the element, so the
     dismissal is tied to *that* wording — change either message and everyone
     sees the new one, without the merchant having to know why. */
  (function () {
    var bar = document.querySelector('[data-announce]');
    if (!bar) return;
    var key = 'gloramous.announce.' + (bar.getAttribute('data-announce-key') || 'x');

    function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

    if (get(key) === '1') {
      bar.hidden = true;
      return;                                   // hidden before paint, no flash
    }
    var x = bar.querySelector('[data-announce-close]');
    if (x) {
      x.addEventListener('click', function () {
        bar.hidden = true;
        set(key, '1');
      });
    }
  })();

  /* ═══ back to top ══════════════════════════════════════════════════════
     The catalogue is over 11,000px tall. Getting back to the filters meant a
     long scroll or the Home key, which most people do not know about. */
  (function () {
    if (document.body.scrollHeight < 4000) return;   // short pages do not need it
    var b = document.createElement('button');
    b.className = 'totop';
    b.type = 'button';
    b.setAttribute('aria-label', 'Back to top');
    b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" aria-hidden="true" focusable="false">' +
      '<path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    document.body.appendChild(b);

    b.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      // send focus somewhere sensible rather than leaving it on a button that
      // is about to disappear
      var main = document.getElementById('main');
      if (main) main.focus({ preventScroll: true });
    });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () {
        b.classList.toggle('is-on', window.scrollY > 900);
        ticking = false;
      }, 120);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  /* ═══ save for later ═══════════════════════════════════════════════════
     121 products, most of them variations on a theme, and prices that make
     people think. A shortlist is the difference between "I will come back to
     this" and closing the tab.

     Kept in the visitor's browser like the recently-viewed list — no account
     needed, nothing sent to the shop. The saved page is rendered from the same
     stored records, so it works with no server involvement at all. */
  (function () {
    var KEY = 'gloramous.saved';

    function read() {
      try {
        var raw = JSON.parse(localStorage.getItem(KEY) || '[]');
        return Object.prototype.toString.call(raw) === '[object Array]' ? raw : [];
      } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (e) {}
      paintCount(list.length);
    }
    function paintCount(n) {
      document.querySelectorAll('[data-saved-count]').forEach(function (el) {
        el.textContent = n ? String(n) : '';
        el.hidden = !n;
      });
      document.querySelectorAll('[data-saved-link]').forEach(function (el) {
        el.classList.toggle('has-items', n > 0);
      });
    }

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }

    var list = read();
    paintCount(list.length);

    /* the heart on a product page */
    var rec = document.querySelector('[data-recent-record]');
    var btn = document.querySelector('[data-save-toggle]');
    if (btn && rec) {
      var item = null;
      try { item = JSON.parse(rec.textContent); } catch (e) {}
      if (item && item.handle) {
        var saved = function () {
          return read().some(function (i) { return i && i.handle === item.handle; });
        };
        var paint = function () {
          var on = saved();
          btn.setAttribute('aria-pressed', String(on));
          btn.classList.toggle('is-on', on);
          var label = btn.querySelector('[data-save-label]');
          if (label) label.textContent = on ? 'Saved' : 'Save for later';
        };
        paint();
        btn.addEventListener('click', function () {
          var cur = read().filter(function (i) { return i && i.handle !== item.handle; });
          if (!saved()) cur.unshift(item);
          write(cur);
          paint();
        });
      }
    }

    /* the saved list, wherever the shell exists */
    var host = document.querySelector('[data-saved]');
    if (!host) return;
    var row = host.querySelector('[data-saved-row]');
    var empty = host.querySelector('[data-saved-empty]');

    function render() {
      var items = read().filter(function (i) { return i && i.handle && i.url; });
      if (!items.length) {
        if (row) row.innerHTML = '';
        if (empty) empty.hidden = false;
        return;
      }
      if (empty) empty.hidden = true;
      row.innerHTML = items.map(function (i) {
        var img = i.image
          ? '<img src="' + esc(i.image) + '" alt="" width="120" height="120" loading="lazy">'
          : '<span class="fam-ph">&middot;</span>';
        var price = (typeof i.price === 'number' && i.price > 0)
          ? '$' + (i.price / 100).toFixed(2) +
            (i.size && i.size !== 'Default Title' ? ' &middot; ' + esc(i.size) : '')
          : 'Request to order';
        return '<li class="family-item"><a class="fam" href="' + esc(i.url) + '" data-l10n-handle="' + esc(i.handle) +
          '" data-l10n-lang="' + esc(i.lang || '') + '">' +
          '<span class="fam-img">' + img + '</span>' +
          '<span class="fam-text"><span class="fam-title" data-l10n-name>' + esc(i.title) + '</span>' +
          '<span class="fam-price">' + price + '</span></span></a>' +
          '<button class="saved-x" type="button" data-unsave="' + esc(i.handle) + '" ' +
          'aria-label="Remove ' + esc(i.title) + ' from saved">&times;</button></li>';
      }).join('');
      if (window.GloramousLocalise) window.GloramousLocalise(row);
    }

    render();
    host.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('[data-unsave]') : null;
      if (!x) return;
      var h = x.getAttribute('data-unsave');
      write(read().filter(function (i) { return i && i.handle !== h; }));
      render();
    });
  })();

  /* ═══ filters collapse on small screens ════════════════════════════════
     Four filter groups and 27 chips is most of a phone screen before a single
     product appears. The groups live in a <details> that JS closes below the
     breakpoint and opens above it — so with no JS the filters are simply open,
     which is the old behaviour rather than a broken control. */
  (function () {
    var d = document.querySelector('[data-filter-drawer]');
    if (!d) return;
    var BP = 720;
    var touched = false;
    d.addEventListener('toggle', function () { touched = true; });

    function sync() {
      if (touched) return;              // the visitor's own choice wins
      d.open = window.innerWidth >= BP;
    }
    sync();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(sync, 150);
    });

    /* how many filters are on, so a collapsed drawer still says something */
    var badge = d.querySelector('[data-filter-count]');
    if (badge) {
      /* Counted from the document, not from `d`. Below 720px the groups are
         moved out of the <details> and into a bottom sheet on <body>, and a
         query rooted at `d` then matches nothing -- the badge would read zero
         with four filters on. */
      var update = function () {
        var n = document.querySelectorAll('.cat-chips .chip[aria-pressed="true"]').length;
        badge.textContent = n ? String(n) : '';
        badge.hidden = !n;
      };
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.cat-chips,[data-cat-clear],.cat-active'))
          setTimeout(update, 0);
      });
      update();
    }
  })();

  /* ── cart: submit on quantity change ──────────────────────────────── */
  /* ── which sticky bars are currently stuck ════════════════════════════
     A sticky element's top EQUALS its `top` offset precisely when it is
     stuck, and is greater than it otherwise. That is exact, it is one rect
     read per bar, and it needs no sentinel and no observer with a rootMargin
     to rebuild every time --head-h changes.

     They need it so they can ride up with the header. Measured before this:
     the glossary bar held at top:68px while the header left, leaving a 68px
     window with the page scrolling through it. */
  var stickAll = (function () {
    var bars = [];
    function refresh() {
      bars = Array.prototype.slice.call(
        document.querySelectorAll('.cat-dock,.gloss-bar'));
    }
    function check() {
      for (var i = 0; i < bars.length; i++) {
        var b = bars[i];
        var want = parseFloat(getComputedStyle(b).top) || 0;
        b.classList.toggle('is-stuck', b.getBoundingClientRect().top <= want + 1);
      }
    }
    function all() { refresh(); check(); }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', all);
    all();
    return all;
  })();

  /* ═══ the phone's filter sheet ═══════════════════════════════════════════
     Below 720px the four filter groups leave the bar and become a bottom
     sheet, and the bar keeps a 44px dock: Filters and Sort, side by side.

     Measured before this existed, at 375x812: the bar was 225px tall and stuck
     at top:0 under a 68px header, so the filter disclosure had 0px visible and
     `.cat-groups` rendered 630px tall -- pushing the result count the filters
     drive below the fold, which is the one number you need while filtering.
     It is now the sheet's own footer button: "Show 34 products".

     The sheet is appended to <body>, not left in the bar. A `position:fixed`
     child of a transformed ancestor positions against that ancestor, and the
     dock IS transformed -- it rides up with the header. Left in place, the
     sheet would have been pinned inside a 44px box. */
  (function () {
    var bar = document.querySelector('.cat-bar');
    var det = document.querySelector('[data-filter-drawer]');
    if (!bar || !det) return;
    var groups = det.querySelector('.cat-groups');
    if (!groups) return;

    var sortLabel = bar.querySelector('.cat-sort');
    var clearBtn = bar.querySelector('[data-cat-clear]');
    var countEl = document.querySelector('[data-cat-count]');
    var summary = det.querySelector('summary');
    var BP = 720;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* where everything came from, so the breakpoint can be crossed twice */
    var gHome = { p: groups.parentNode, n: groups.nextSibling };
    var dHome = { p: det.parentNode, n: det.nextSibling };
    var sHome = sortLabel ? { p: sortLabel.parentNode, n: sortLabel.nextSibling } : null;

    Array.prototype.forEach.call(groups.children, function (g, i) {
      g.style.setProperty('--gi', i);          // stagger index for the rise
    });

    var dock = null;
    var sheet = null, panel = null, grab = null, sbody = null, showBtn = null;
    var open = false, lastFocus = null;

    function phone() { return window.innerWidth < BP; }

    /* ── haptics, where the platform has them ────────────────────────────
       Android Chrome only: Safari has never shipped navigator.vibrate and
       there is no iOS equivalent from a web page. Feature-detected rather
       than sniffed, so it simply does nothing where it does not exist. */
    function tap(ms) {
      if (navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) {} }
    }

    /* ── the sheet, built once ───────────────────────────────────────────── */
    function makeSheet() {
      sheet = document.createElement('div');
      sheet.className = 'sheet';
      sheet.setAttribute('data-filter-sheet', '');
      sheet.innerHTML =
        '<div class="sheet-scrim" data-sheet-scrim></div>' +
        '<div class="sheet-panel" role="dialog" aria-modal="true" aria-label="Filters">' +
          '<div class="sheet-grab" data-sheet-grab data-title="' + ((window.GloramousT && window.GloramousT('Filters')) || 'Filters') + '"></div>' +
          '<div class="sheet-body" data-sheet-body></div>' +
          '<div class="sheet-foot">' +
            '<button class="chip sheet-clear" type="button" data-sheet-clear>Clear</button>' +
            '<button class="sheet-show" type="button" data-sheet-show>Show results</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(sheet);
      panel = sheet.querySelector('.sheet-panel');
      grab = sheet.querySelector('[data-sheet-grab]');
      sbody = sheet.querySelector('[data-sheet-body]');
      showBtn = sheet.querySelector('[data-sheet-show]');

      sheet.querySelector('[data-sheet-scrim]').addEventListener('click', hide);
      showBtn.addEventListener('click', function () { tap(8); hide(); });
      sheet.querySelector('[data-sheet-clear]').addEventListener('click', function () {
        tap(12);
        if (clearBtn) clearBtn.click();
      });
      /* a chip inside the sheet answers with 6ms, which is the shortest pulse
         an Android vibrator will actually render as a tick rather than a buzz */
      sbody.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.chip')) tap(6);
      });
      wireDrag();
      mirrorCount();
    }

    /* ── the footer button says what pressing it will show, live ─────────
       Counted off the grid, NOT copied from the count element. motion.js
       turns that number into an odometer -- every digit place becomes a strip
       of 0-9 that rolls -- so its text genuinely contains twenty digits and
       the button read "Show 4301234567890123456789 of 62 products". The count
       element is presentation that another feature is already animating; how
       many results there are is a fact about the grid. The filter marks each
       card `hidden`, which is the same state the count is derived FROM, one
       step earlier and with nothing painted over it. */
    function mirrorCount() {
      if (!showBtn) return;
      var host = document.querySelector('[data-catalogue]');
      var grid = document.querySelector('[data-cat-grid]');
      if (!grid) { showBtn.textContent = 'Show results'; return; }
      var noun = (host && host.getAttribute('data-count-noun')) || 'product';
      var paint = function () {
        var shown = grid.querySelectorAll('.card:not([hidden])').length;
        showBtn.innerHTML = 'Show <b>' + shown + '</b> ' +
                            noun + (shown === 1 ? '' : 's');
      };
      paint();
      /* the count element is still the trigger -- it changes exactly once per
         finished filter pass -- but nothing is read out of it */
      if (countEl && 'MutationObserver' in window) {
        new MutationObserver(paint).observe(countEl,
          { childList: true, characterData: true, subtree: true });
      }
    }

    /* ── drag to dismiss ─────────────────────────────────────────────────── */
    function wireDrag() {
      var id = null, y0 = 0, dy = 0, trail = [];

      grab.addEventListener('pointerdown', function (e) {
        if (!open || (e.pointerType === 'mouse' && e.button !== 0)) return;
        id = e.pointerId;
        y0 = e.clientY;
        dy = 0;
        trail = [{ y: e.clientY, t: performance.now() }];
        try { grab.setPointerCapture(id); } catch (_) {}
        sheet.classList.add('is-dragging');
      });

      grab.addEventListener('pointermove', function (e) {
        if (id === null || e.pointerId !== id) return;
        dy = e.clientY - y0;
        /* upward is resisted, not blocked. A sheet that simply stops moving
           reads as broken; one that resists reads as attached to the bottom. */
        var v = dy < 0 ? dy * 0.18 : dy;
        panel.style.transform = 'translate3d(0,' + v.toFixed(1) + 'px,0)';
        /* the backdrop lightens as the sheet leaves. A scrim that stays flat
           until the gesture commits is what makes a drag feel unattached to
           anything -- you are moving one object in front of a still image. */
        var h0 = panel.getBoundingClientRect().height || 1;
        sheet.style.setProperty('--sheet-drag',
          Math.max(0, Math.min(1, v / h0)).toFixed(3));
        trail.push({ y: e.clientY, t: performance.now() });
        if (trail.length > 10) trail.shift();
      });

      function release(e) {
        if (id === null || (e && e.pointerId !== id)) return;
        var pid = id; id = null;
        try { grab.releasePointerCapture(pid); } catch (_) {}
        sheet.classList.remove('is-dragging');
        if (!trail.length) { sheet.style.removeProperty('--sheet-drag'); return; }

        /* velocity over the trailing 90ms, not over the whole gesture: a
           slow drag that ends in a flick should dismiss, and averaging the
           whole gesture erases the flick */
        var end = trail[trail.length - 1], i = trail.length - 1;
        while (i > 0 && end.t - trail[i - 1].t < 90) i--;
        var dt = end.t - trail[i].t;
        var vel = dt > 0 ? (end.y - trail[i].y) / dt * 1000 : 0;
        var h = panel.getBoundingClientRect().height || 1;

        /* PROJECTED POSITION, not distance-or-velocity. Measured with two
           independent thresholds: a deliberate 55px drag dismissed the sheet,
           because it happened to run at 760 px/s and tripped the velocity
           test on its own. Two thresholds means the union of them, and the
           union is bigger than either.

           So ask where the gesture is GOING: carry it forward by its velocity
           over a 150ms horizon and compare once. The two cases that must
           differ -- 62px travelled slowly and 62px flicked -- then land on
           opposite sides of one number. */
        var projected = dy + vel * 0.15;

        /* clearing the inline transform first is deliberate: the class-based
           transform is what the panel must animate TO, and both changes land
           in the same task, so the style resolves once and the panel travels
           from where the finger left it straight to its target. */
        panel.style.transform = '';
        sheet.style.removeProperty('--sheet-drag');
        if (projected > h * 0.28) { tap(10); hide(); }
      }
      grab.addEventListener('pointerup', release);
      grab.addEventListener('pointercancel', release);
      grab.addEventListener('lostpointercapture', release);
    }

    /* ── open and close ──────────────────────────────────────────────────── */
    function lock(v) { document.documentElement.classList.toggle('is-locked', v); }

    function showSheet() {
      if (open || !sheet) return;
      open = true;
      lastFocus = document.activeElement;
      sheet.classList.add('is-live');
      lock(true);
      tap(9);
      /* A forced reflow, not a requestAnimationFrame. What the transition
         needs is a guaranteed start value for the transform, and reading
         offsetHeight resolves style and layout synchronously right here. rAF
         only promises "some time before the next paint" -- which is never at
         all if the rendering loop is not advancing, and is two frames of
         latency on a phone when it is. */
      void panel.offsetHeight;
      sheet.classList.add('is-open');
      if (summary) summary.setAttribute('aria-expanded', 'true');
      var first = sbody.querySelector('.chip');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 120);
    }

    function hide() {
      if (!open || !sheet) return;
      open = false;
      sheet.classList.remove('is-open');
      lock(false);
      if (summary) summary.setAttribute('aria-expanded', 'false');
      var done = function () {
        if (!open) sheet.classList.remove('is-live');
        panel.removeEventListener('transitionend', done);
      };
      panel.addEventListener('transitionend', done);
      /* transitionend never fires in a hidden document or with reduced
         motion, and a sheet left `is-live` swallows every tap on the page */
      setTimeout(done, reduce ? 0 : 540);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    /* the summary is the trigger; the <details> never opens in flow on a
       phone, because its content is somewhere else entirely */
    det.addEventListener('click', function (e) {
      if (!phone() || !dock) return;
      if (!e.target.closest('summary')) return;
      e.preventDefault();
      det.open = false;
      if (open) hide(); else showSheet();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && open) { e.preventDefault(); hide(); }
    });

    /* ── the dock knows when it is stuck ─────────────────────────────────
       It only rides up with the header once it is actually pinned there.
       Translating a bar still sitting in its natural position just lifts it
       off its own baseline for no reason.

       The test is exact rather than approximate: a sticky element's top EQUALS
       its `top` offset precisely when it is stuck, and is greater than it
       otherwise. That is one rect read on one element per scroll -- and it
       replaces a 1px sentinel, an IntersectionObserver, and a rootMargin that
       had to be rebuilt every time --head-h changed. */
    function watchStick() { stickAll(); }

    /* ── build and tear down across the breakpoint ───────────────────────── */
    function build() {
      if (dock) return;
      dock = document.createElement('div');
      dock.className = 'cat-dock';
      /* AFTER `.cat-bar`, not inside it. A sticky element can only stick
         within its parent's box, and the bar is ~150px tall on a phone -- the
         dock scrolled away with it and was measured at top:-729px. As a
         sibling its containing block is the catalogue section, which spans the
         whole grid. (Which is also why `.cat-bar` has always stuck correctly
         on desktop: same parent, full-height box.) */
      bar.parentNode.insertBefore(dock, bar.nextSibling);
      dock.appendChild(det);
      if (sortLabel) dock.appendChild(sortLabel);
      if (summary) {
        summary.setAttribute('aria-haspopup', 'dialog');
        summary.setAttribute('aria-expanded', 'false');
      }
      if (!sheet) makeSheet();
      sbody.appendChild(groups);
      det.open = false;
      watchStick();
    }

    function teardown() {
      if (!dock) return;
      if (open) hide();
      gHome.p.insertBefore(groups, gHome.n);
      dHome.p.insertBefore(det, dHome.n);
      if (sHome) sHome.p.insertBefore(sortLabel, sHome.n);
      dock.remove();
      dock = null;
      if (summary) {
        summary.removeAttribute('aria-haspopup');
        summary.removeAttribute('aria-expanded');
      }
      det.open = true;
    }

    function sync() { if (phone()) build(); else teardown(); }
    sync();
    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(sync, 160);
    });
  })();

  /* ═══ the featured row, as a phone carousel ══════════════════════════════
     Two columns at 375px makes each product a 150px thumbnail and puts the
     fifth one below the fold with nothing to say it exists.

     The snapping is the browser's: `scroll-snap-type` runs on the compositor,
     so it keeps working through a busy main thread in a way a JS carousel
     does not. This only adds the emphasis and the counter -- and it reads
     `scrollLeft` against offsets measured once, so a frame of scrolling costs
     arithmetic instead of one rect read per card. */
  (function () {
    var strips = document.querySelectorAll('.fgrid');
    if (!strips.length) return;
    var BP = 720;

    Array.prototype.forEach.call(strips, function (strip) {
      var kids = Array.prototype.slice.call(strip.children);
      if (kids.length < 3) return;                 // a strip of two is a grid

      var counter = document.createElement('p');
      counter.className = 'carousel-count';
      counter.setAttribute('aria-hidden', 'true'); // the cards are the content
      strip.parentNode.insertBefore(counter, strip.nextSibling);

      var offs = [], span = 1, on = false;

      /* measured once per layout, not once per frame.

         Relative to the FIRST card, not absolute. `offsetLeft` is measured
         from the nearest positioned ancestor rather than from the scroll
         container, so every offset carried a constant 23px of the wrap's
         padding while `scrollLeft` starts at 0 -- and --snap peaked at 0.913
         instead of 1. Anchoring to the first card puts the offsets in the one
         frame `scrollLeft` shares. */
      function measure() {
        var base = kids[0].offsetLeft;
        /* absolute: in Arabic (RTL) offsets and scrollLeft run negative, and a
           negative span turned the dimming into enlarging (cards grew to 1.13) */
        offs = kids.map(function (k) { return Math.abs(k.offsetLeft - base); });
        span = (offs[1] || 0) || kids[0].offsetWidth || 1;
      }

      function paint() {
        var x = Math.abs(strip.scrollLeft);
        var lead = 0, best = Infinity;
        for (var i = 0; i < kids.length; i++) {
          var d = Math.abs(offs[i] - x);
          /* 1 at the leading edge, falling linearly to 0 one card away */
          kids[i].style.setProperty('--snap',
            Math.max(0, 1 - d / span).toFixed(3));
          if (d < best) { best = d; lead = i; }
        }
        counter.innerHTML = '<b>' + String(lead + 1) + '</b>&thinsp;/&thinsp;' +
                            kids.length;
      }

      function enable() {
        if (on) return;
        on = true;
        strip.classList.add('is-carousel');
        strip.setAttribute('role', 'group');
        strip.setAttribute('aria-roledescription', 'carousel');
        strip.tabIndex = 0;                        // reachable without a swipe
        measure();
        paint();
        strip.addEventListener('scroll', paint, { passive: true });
      }

      function disable() {
        if (!on) return;
        on = false;
        strip.classList.remove('is-carousel');
        strip.removeAttribute('role');
        strip.removeAttribute('aria-roledescription');
        strip.removeAttribute('tabindex');
        strip.removeEventListener('scroll', paint);
        kids.forEach(function (k) { k.style.removeProperty('--snap'); });
        counter.textContent = '';
      }

      function sync() {
        if (window.innerWidth < BP) { enable(); measure(); paint(); }
        else disable();
      }
      sync();
      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(sync, 160);
      });
    });
  })();

  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) cartForm.submit();
    });
  }
})();

/* ── the light follows the pointer ──────────────────────────────────────────
   Two numbers, written on pointermove, and nothing else. The easing is a CSS
   transition on the transform, so there is no animation loop to throttle or
   leak -- and the behaviour can be verified by dispatching one synthetic
   pointer event and reading a computed style, which an rAF-eased version could
   not be in a hidden document.

   `pointerraw`-style high-frequency events are deliberately NOT used: a
   transition is doing the smoothing, so more samples buy nothing and cost main
   -thread time.

   Gated the same way the CSS is. The attribute is what the CSS hangs off, so
   if the gate fails the layer is never rendered and the listener never bound --
   one condition, not two that can disagree. */
(function () {
  'use strict';
  var media = document.querySelector('[data-hero-media]');
  if (!media) return;
  if (media.closest('.hero-full--video')) return;   // the video carries its own light
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  if (!window.matchMedia('(pointer: fine)').matches) return;

  media.setAttribute('data-lamp', '');

  media.addEventListener('pointermove', function (e) {
    var r = media.getBoundingClientRect();
    if (!r.width || !r.height) return;
    var x = (e.clientX - r.left) / r.width;
    var y = (e.clientY - r.top) / r.height;
    // clamped: a pointer can report just outside the box on the edges
    media.style.setProperty('--px', Math.max(0, Math.min(1, x)).toFixed(4));
    media.style.setProperty('--py', Math.max(0, Math.min(1, y)).toFixed(4));
  });

  media.addEventListener('pointerleave', function () {
    media.style.setProperty('--px', '0.5');
    media.style.setProperty('--py', '0.5');
  });
})();

/* ══ HERO VIDEO (2026-09-19) ═══════════════════════════════════════════════
   Phones get a smaller copy of the same edit; it plays only while on screen, and
   "reduce motion" keeps the poster: the same frame the edit opens and closes on. */
(function () {
  'use strict';
  var v = document.querySelector('[data-hero-video]');
  if (!v) return;
  var wide = window.matchMedia('(min-width: 900px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var seen = false;
  function attach() {
    /* phones get the small file: same edit, about 500 KB instead of 1.3 MB */
    var want = (wide.matches ? v.getAttribute('data-mp4') : (v.getAttribute('data-mp4-mobile') || v.getAttribute('data-mp4')));
    if (!want || v.getAttribute('data-ready') === want) return;
    v.setAttribute('data-ready', want);
    v.innerHTML = '';
    var s = document.createElement('source');
    s.src = want; s.type = 'video/mp4';
    v.appendChild(s);
    v.load();
  }
  function sync() {
    if (calm.matches || !seen) { v.pause(); return; }
    attach();
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { seen = es[0].isIntersecting; sync(); }, { threshold: 0.2 }).observe(v.parentNode);
  } else { seen = true; sync(); }
  [wide, calm].forEach(function (m) {
    if (m.addEventListener) m.addEventListener('change', sync); else if (m.addListener) m.addListener(sync);
  });
})();

/* ══════════════════════════════════════════════════════════════════════════
   THE CALM ROUND (2026-09-16) -- five small behaviours
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. the floating WhatsApp button writes its own message ──────────────
     On a product page it names the product and the size selected at the moment
     of the tap, so the first reply is an answer rather than "which one?". It
     steps aside when the footer is on screen, because the footer carries the
     same number. */
  var wa = document.querySelector('[data-wa-float]');
  if (wa) {
    var waBase = wa.getAttribute('href').split('?')[0];
    var waMsg = function () {
      var name = wa.getAttribute('data-wa-product');
      var ar = /^ar\b/.test(document.documentElement.lang || '');
      if (!name) return ar ? 'مرحبًا Gloramous، لدي سؤال.' : 'Hello Gloramous, I have a question.';
      if (ar) {
        var szA = document.querySelector('.product-meta [data-variant-size]');
        var sa = szA ? szA.textContent.trim() : '';
        return 'مرحبًا Gloramous، لدي سؤال عن ' + name + (sa && sa !== 'Default Title' ? ' (' + sa + ')' : '') + '.';
      }
      var sz = document.querySelector('.product-meta [data-variant-size]');
      var size = sz ? sz.textContent.trim() : '';
      return 'Hello Gloramous, I have a question about ' + name +
             (size && size !== 'Default Title' ? ' (' + size + ')' : '') + '.';
    };
    var waSync = function () { wa.href = waBase + '?text=' + encodeURIComponent(waMsg()); };
    waSync();
    ['pointerdown', 'focus', 'click'].forEach(function (t) { wa.addEventListener(t, waSync); });

    var foot = document.querySelector('.site-foot');
    var waWait = false;
    var waPlace = function () {
      var top = foot ? foot.getBoundingClientRect().top : Infinity;
      wa.classList.toggle('is-away', top < window.innerHeight - 40);
    };
    window.addEventListener('scroll', function () {
      if (waWait) return;
      waWait = true;
      setTimeout(function () { waPlace(); waWait = false; }, 120);
    }, { passive: true });
    waPlace();
  }

  /* ── 2. share a product ──────────────────────────────────────────────────
     The system share sheet where there is one (every phone, where WhatsApp
     lives); otherwise the link is copied and the label says so. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-share]') : null;
    if (!b) return;
    var url = b.getAttribute('data-share-url') || location.href.split('#')[0];
    var title = b.getAttribute('data-share-title') || document.title;
    var label = b.querySelector('[data-share-label]');
    var said = function (text) {
      if (!label) return;
      label.textContent = text;
      clearTimeout(b._t);
      b._t = setTimeout(function () { label.textContent = 'Share'; }, 2200);
    };
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () { said('Link copied'); },
        function () { said('Copy failed'); });
    } else {
      window.prompt('Copy this link', url);
    }
  });

  /* ── 3. the announcement bar shows one message at a time on a phone ──────
     Three messages wrapped to two cramped lines at 390px. Now they take turns,
     crossfading every five seconds. The pointer or focus on the bar pauses it
     (WCAG 2.2.2), and a closed bar stops ticking. */
  var bar = document.querySelector('[data-announce]');
  var msgs = bar ? bar.querySelectorAll('.announce-in > span') : [];
  if (bar && msgs.length > 1) {
    var narrow = window.matchMedia('(max-width:719px)');
    var at = 0, timer = null, paused = false;
    var show = function (i) {
      for (var k = 0; k < msgs.length; k++) msgs[k].classList.toggle('is-current', k === i);
    };
    var tick = function () {
      if (paused || bar.hidden) return;
      at = (at + 1) % msgs.length;
      show(at);
    };
    var setup = function () {
      clearInterval(timer);
      if (narrow.matches) {
        bar.classList.add('is-rotating');
        show(at);
        timer = setInterval(tick, 5000);
      } else {
        bar.classList.remove('is-rotating');
        for (var k = 0; k < msgs.length; k++) msgs[k].classList.remove('is-current');
      }
    };
    bar.addEventListener('pointerenter', function () { paused = true; });
    bar.addEventListener('pointerleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    if (narrow.addEventListener) narrow.addEventListener('change', setup);
    setup();
  }

  /* ── 4. "/" opens search, as it does on most shops people know ─────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
    var open = document.querySelector('[data-search-open]');
    if (!open) return;
    e.preventDefault();
    open.click();
  });

  /* ── 5. product photographs fade in instead of popping in ────────────────
     Only images not yet loaded get the class, and the class is added by
     script, so with no JS every image is simply visible. */
  if (!reduce) {
    document.querySelectorAll('.card-img img,.fcard-img img,.big-img img,.product-media img')
      .forEach(function (img) {
        if (img.complete) return;
        img.classList.add('is-loading');
        var done = function () { img.classList.remove('is-loading'); };
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
  }
})();

/* ══════════════════════════════════════════════════════════════════════════
   SMOOTHER AND EASIER (2026-09-16, second calm round)
   Every animation here is either a fade or a short move the shopper caused,
   and every one of them does a job: it shows where something went, or that a
   value changed. Nothing moves with the scroll or with the pointer.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PREVIEW = !!window.GLORAMOUS_PREVIEW;

  /* ── 1. a value that changes rolls into place ────────────────────────────
     Prices when a size is picked, the drawer subtotal, the quick view price.
     Only the new value moves, 60% of a line, clipped -- the eye sees that it
     changed without anything sliding across the page. */
  function roll(el, html) {
    if (!el) return;
    var key = String(html);
    /* the server-rendered value is the starting point, so the very first
       change rolls too -- it did not, which made the first size switch silent */
    if (!el.hasAttribute('data-roll')) el.setAttribute('data-roll', el.innerHTML.trim());
    var before = el.getAttribute('data-roll');
    if (before === key) return;
    el.setAttribute('data-roll', key);
    // nothing to roll from (an empty subtotal on first open): just write it
    if (!before || CALM) { el.innerHTML = html; return; }
    el.innerHTML = '<span class="roll"><span class="roll-in">' + html + '</span></span>';
  }
  window.GloramousRoll = roll;

  /* ── 2. the selected size has a highlight that slides to the new choice ──
     One element behind the buttons, moved to the pressed one. It is how a
     segmented control on a phone behaves, and it makes the choice feel like
     a single control rather than four separate buttons. */
  function glide(box) {
    if (!box || CALM) return;
    var g = box.querySelector(':scope > .opts-glider');
    if (!g) {
      g = document.createElement('span');
      g.className = 'opts-glider';
      g.setAttribute('aria-hidden', 'true');
      box.insertBefore(g, box.firstChild);
      box.classList.add('has-glider');
    }
    var on = box.querySelector('button[aria-pressed="true"]');
    if (!on || !on.offsetWidth) { g.style.opacity = '0'; return; }
    g.style.opacity = '1';
    g.style.width = on.offsetWidth + 'px';
    g.style.height = on.offsetHeight + 'px';
    g.style.transform = 'translate(' + on.offsetLeft + 'px,' + on.offsetTop + 'px)';
    // first placement is instant; after that it travels
    if (!box.classList.contains('glide-ready')) {
      setTimeout(function () { box.classList.add('glide-ready'); }, 60);
    }
  }
  window.GloramousGlide = glide;

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 ? v.toFixed(2) : String(v));
  }

  document.querySelectorAll('[data-opts]').forEach(function (box) {
    /* ── 3. each size says what it costs ──────────────────────────────────
       "280 mL" and "500 mL" with the price under each, so choosing a size is
       not a guess followed by a look at the price. The button keeps its
       data-size, which is what everything else reads. */
    box.querySelectorAll('button[data-price-cents]').forEach(function (b) {
      if (b.querySelector('.opt-price')) return;
      var c = parseInt(b.getAttribute('data-price-cents'), 10);
      if (!c) return;
      var s = document.createElement('small');
      s.className = 'opt-price';
      s.textContent = money(c);
      b.appendChild(s);
    });
    glide(box);
    new MutationObserver(function () { glide(box); })
      .observe(box, { attributes: true, attributeFilter: ['aria-pressed'], subtree: true });
  });
  var glideTimer;
  window.addEventListener('resize', function () {
    clearTimeout(glideTimer);
    glideTimer = setTimeout(function () {
      document.querySelectorAll('.has-glider').forEach(function (b) {
        b.classList.remove('glide-ready');
        glide(b);
      });
    }, 120);
  });

  /* ── 4. the product photograph carries over to the product page ─────────
     Click a card and its photo grows into the product page's photo instead of
     the page blinking. Going back, the photo returns to its card. Chrome and
     Safari (cross-document view transitions); elsewhere, a normal page load. */
  var VT_NAME = 'product-photo';
  function clearNames() {
    document.querySelectorAll('[data-vt-named]').forEach(function (el) {
      el.style.viewTransitionName = '';
      el.removeAttribute('data-vt-named');
    });
  }
  if (!CALM && 'onpagereveal' in window) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.target.closest && e.target.closest('button')) return;
      var a = e.target.closest ? e.target.closest('a.card, a.fcard, a.big, a.rv-card, .recent-row a, .related a') : null;
      if (!a) return;
      var img = a.querySelector('img');
      if (!img) return;
      clearNames();
      img.style.viewTransitionName = VT_NAME;
      img.setAttribute('data-vt-named', '');
    });
    window.addEventListener('pageshow', clearNames);

    window.addEventListener('pagereveal', function (e) {
      if (!e.viewTransition) return;
      var act = window.navigation && navigation.activation;
      var from = act && act.from && act.from.url;
      if (!from) return;
      var path;
      try { path = new URL(from).pathname; } catch (err) { return; }
      var main = document.querySelector('[data-gallery-main], .product-media img');
      // arriving on a product page from anywhere: its photo is the target
      if (main) {
        main.style.viewTransitionName = VT_NAME;
        main.setAttribute('data-vt-named', '');
      } else {
        // arriving back on a grid from a product: find that product's card
        var card = [].find.call(document.querySelectorAll('a.card, a.fcard, a.big'), function (x) {
          try { return new URL(x.href, location.href).pathname === path; } catch (err) { return false; }
        });
        var img = card && card.querySelector('img');
        if (img && img.getClientRects().length) {
          img.style.viewTransitionName = VT_NAME;
          img.setAttribute('data-vt-named', '');
        }
      }
      e.viewTransition.finished.then(clearNames, clearNames);
    });
  }

  /* ── 5. the desktop catalogue shows two filter rows, not four ────────────
     Category and Concern are what people choose by; Price and Type fold
     behind "More filters". If anything in them is already chosen -- a shared
     link, the back button -- they start open, so no active filter is hidden. */
  document.querySelectorAll('.cat-groups').forEach(function (groups) {
    var list = [].filter.call(groups.children, function (c) { return c.classList.contains('cat-group'); });
    if (list.length < 3) return;
    var extra = list.slice(2);
    extra.forEach(function (g) { g.classList.add('is-extra'); });
    var names = extra.map(function (g) {
      var l = g.querySelector('.cat-label');
      return l ? l.textContent.trim() : '';
    }).filter(Boolean);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cat-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>More filters</span><small>' + names.join(', ') + '</small>' +
      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
      'stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
    list[1].insertAdjacentElement('afterend', btn);
    function set(open) {
      groups.classList.toggle('is-folded', !open);
      btn.setAttribute('aria-expanded', String(open));
      btn.querySelector('span').textContent = open ? 'Fewer filters' : 'More filters';
    }
    var anyOn = extra.some(function (g) { return g.querySelector('[aria-pressed="true"]'); });
    set(!!anyOn);
    btn.addEventListener('click', function () {
      set(btn.getAttribute('aria-expanded') !== 'true');
    });
  });

  /* ── 6. the email signup answers in the preview ──────────────────────────
     On Shopify the form posts and the page comes back with its message. The
     static preview has nowhere to post, so the button did nothing at all. */
  if (PREVIEW) {
    document.addEventListener('submit', function (e) {
      var f = e.target.closest ? e.target.closest('.news-form') : null;
      if (!f) return;
      e.preventDefault();
      var inp = f.querySelector('input[type="email"]');
      if (inp && !inp.checkValidity()) { inp.reportValidity(); return; }
      var msg = document.createElement('p');
      msg.className = 'news-msg is-ok news-done';
      msg.setAttribute('role', 'status');
      msg.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        '<path class="tick" d="M5 12.5l4.5 4.5L19 7.5"/></svg>Thank you, you are on the list.';
      f.replaceWith(msg);
    }, true);
  }
})();

/* ══════════════════════════════════════════════════════════════════════════
   THE CLIPS ON THE SITE (2026-09-16)
   Three uses:
     a card's clip plays while the pointer is over it (desktop only),
     Watch on a product page swaps the photo for its clip,
     the homepage film plays muted on a loop while it is on screen (the user
     asked for that on 2026-09-23, and for no pause button).
   With reduced motion asked for, only Watch plays, because the shopper starts it;
   the film keeps its poster.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var SAVE = !!(navigator.connection && navigator.connection.saveData);

  /* ── card hover clips ──────────────────────────────────────────────────
     The video element is created on the first hover, not on load: sixty
     cards must not download sixty clips. It fades in over the photograph
     once it is actually playing, so a slow connection shows the photo rather
     than a black frame. */
  if (!CALM && FINE && !SAVE) {
    document.querySelectorAll('[data-hover-video]').forEach(function (el) {
      var card = el.closest('a') || el;
      var host = el.matches('.card-img,.fcard-img,.big-img') ? el
        : el.querySelector('.card-img,.fcard-img,.big-img');
      if (!host) return;
      var src = el.getAttribute('data-hover-video');
      var v = null, stop = null;
      card.addEventListener('pointerenter', function () {
        if (!v) {
          v = document.createElement('video');
          v.className = 'hover-video';
          v.muted = true; v.loop = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
          v.setAttribute('aria-hidden', 'true');
          v.preload = 'auto';
          v.src = src;
          host.appendChild(v);
          v.addEventListener('playing', function () {
            if (card.matches(':hover')) host.classList.add('is-playing');
          });
        }
        clearTimeout(stop);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        if (!v.paused && v.readyState > 2) host.classList.add('is-playing');
      });
      card.addEventListener('pointerleave', function () {
        host.classList.remove('is-playing');
        stop = setTimeout(function () {
          if (v) { v.pause(); try { v.currentTime = 0; } catch (e) {} }
        }, 450);
      });
    });
  }

  /* ── Watch, on a product page ─────────────────────────────────────────── */
  document.querySelectorAll('[data-watch]').forEach(function (b) {
    var media = b.closest('.product-media');
    if (!media) return;
    var v = null;
    var label = b.querySelector('span');
    b.addEventListener('click', function () {
      var on = !media.classList.contains('is-watching');
      media.classList.toggle('is-watching', on);
      b.setAttribute('aria-pressed', String(on));
      if (label) label.textContent = on ? 'Photo' : 'Watch';
      if (on) {
        if (!v) {
          v = document.createElement('video');
          v.className = 'pwatch-video';
          v.muted = true; v.loop = true; v.playsInline = true;
          v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
          v.src = b.getAttribute('data-watch');
          media.insertBefore(v, b);
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (v) {
        v.pause();
      }
    });
  });

  /* ── the homepage film (2026-09-23: muted, on a loop, on its own) ────────
     Plays while at least a quarter of it is on screen and pauses when it
     leaves, so it never burns data or battery out of sight. "Reduce motion"
     keeps the poster. No pause button (the user asked for it to go): tapping
     the film pauses it and tapping again plays it, and from then on the
     visitor's choice wins over scrolling. */
  document.querySelectorAll('[data-film-frame]').forEach(function (frame) {
    var v = frame.querySelector('video[data-film]');
    if (!v) return;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var seen = false, chosen = null;           /* chosen: 'play' | 'pause' | null */
    v.muted = true; v.defaultMuted = true;
    function sync() {
      if (seen && (chosen ? chosen === 'play' : !calm.matches)) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    }
    function toggle() { chosen = v.paused ? 'play' : 'pause'; sync(); }
    v.addEventListener('click', toggle);
    v.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; sync(); }, { threshold: 0.25 }).observe(frame);
    } else { seen = true; sync(); }
    if (calm.addEventListener) calm.addEventListener('change', sync); else if (calm.addListener) calm.addListener(sync);
  });
})();

/* ══════════════════════════════════════════════════════════════════════════
   HOMEPAGE SECTIONS (2026-09-16): signature film and one-press adds
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── buttons that add one or several products at once ────────────────────
     The signature product and the three-step routine. On Shopify it is one
     /cart/add.js with an items array, then the drawer opens on the real cart;
     in the preview the in-memory cart takes the same lines. */
  document.querySelectorAll('[data-add-lines]').forEach(function (b) {
    var label = b.textContent;
    b.addEventListener('click', function () {
      var lines;
      try { lines = JSON.parse(b.getAttribute('data-add-lines')); } catch (e) { return; }
      if (!lines.length || !window.GloramousCart) return;
      b.disabled = true;
      b.textContent = 'Adding…';
      var done = function () {
        b.textContent = 'Added';
        setTimeout(function () { b.disabled = false; b.textContent = label; }, 1600);
      };
      var fail = function () {
        b.disabled = false;
        b.textContent = 'Could not add, try again';
        setTimeout(function () { b.textContent = label; }, 2400);
      };
      if (window.GLORAMOUS_PREVIEW) {
        var p = window.GloramousCart.addMany(lines.map(function (l) {
          return { id: l.id, title: l.title,
                   variant: l.variant === 'Default Title' ? '' : l.variant,
                   price: l.price, image: l.image };
        }));
        (p && p.then ? p : Promise.resolve()).then(done, fail);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: 1 }; }) })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return window.GloramousCart.open(lines.length > 1 ? lines.length + ' products added' : 'Added to cart');
      }).then(done, fail);
    });
  });

  /* ── the signature film plays only while it is on screen ─────────────────
     Muted, and never for reduced-motion visitors, who keep the photograph. */
  document.querySelectorAll('[data-sig-video]').forEach(function (v) {
    var box = v.closest('.sig-media');
    if (CALM || !('IntersectionObserver' in window)) { v.remove(); return; }
    v.addEventListener('playing', function () { if (box) box.classList.add('is-playing'); });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.35 }).observe(v);
  });
})();

/* ══════════════════════════════════════════════════════════════════════════
   NAVBAR, CATALOGUE SHORTCUTS (2026-09-16)
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── the header turns to frosted glass once the page moves ───────────────
     The IntersectionObserver near the top of this file already sets
     .is-stuck; this scroll check is the same signal for browsers and embeds
     where observers are throttled, and it costs one comparison. */
  var head = document.querySelector('.site-head');
  if (head) {
    var glass = function () { head.classList.toggle('is-glass', window.scrollY > 8); };
    window.addEventListener('scroll', glass, { passive: true });
    glass();
  }

  /* ── the Catalogue mega menu: aria-expanded and Escape ─────────────────
     The panel opens in CSS on :hover and :focus-within. The trigger said
     aria-expanded="false" the whole time and nothing closed the panel, which
     fails WCAG 1.4.13 for content shown on hover or focus. Escape adds
     .is-shut (theme.css hides the panel with it) and keeps focus on the
     trigger; the class clears once the pointer and focus have both left. */
  document.querySelectorAll('[data-mega]').forEach(function (item) {
    var t = item.querySelector('[data-mega-trigger]');
    if (!t) return;
    function sync(hover, focus) {
      if (!hover && !focus) item.classList.remove('is-shut');
      t.setAttribute('aria-expanded', String((hover || focus) && !item.classList.contains('is-shut')));
    }
    item.addEventListener('mouseenter', function () { sync(true, item.contains(document.activeElement)); });
    item.addEventListener('mouseleave', function () { sync(false, item.contains(document.activeElement)); });
    item.addEventListener('focusin', function () { sync(item.matches(':hover'), true); });
    item.addEventListener('focusout', function (e) { sync(item.matches(':hover'), item.contains(e.relatedTarget)); });
    document.addEventListener('keydown', function (e) {
      var focus = item.contains(document.activeElement);
      if (e.key !== 'Escape' || !(focus || item.matches(':hover'))) return;
      item.classList.add('is-shut');
      if (focus) t.focus();
      t.setAttribute('aria-expanded', 'false');
    });
  });

  /* ── the phone menu is a full panel: lock the page behind it ────────────── */
  var menu = document.querySelector('details.nav-toggle');
  if (menu) {
    menu.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('menu-open', menu.open);
      var head = document.querySelector('.site-head');
      if (menu.open && head) document.documentElement.style.setProperty('--menu-top',
        Math.round(head.getBoundingClientRect().bottom) + 'px');
    });
    menu.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.nav-panel a') : null;
      if (a) { menu.open = false; }
    });
  }

  /* ── the bottom bar hands over to the header's own search and cart ──────── */
  var tabSearch = document.querySelector('[data-tab-search]');
  if (tabSearch) {
    tabSearch.addEventListener('click', function () {
      var open = document.querySelector('[data-search-open]');
      /* after this click has finished: the search panel closes on any click
         outside itself, and this very click would otherwise count as one */
      /* no jump to the top: the search sits in the sticky header, so the
         shopper keeps their place on the page */
      if (open) setTimeout(function () { open.click(); }, 0);
    });
  }
  var tabCart = document.querySelector('[data-tab-cart]');
  if (tabCart) {
    tabCart.addEventListener('click', function (e) {
      var real = document.querySelector('.site-head .cart-link:not(.saved-link)');
      if (!real || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      real.click();
    });
  }
  // mark where we are
  var path = location.pathname;
  document.querySelectorAll('.tabbar [data-tab]').forEach(function (a) {
    var t = a.getAttribute('data-tab');
    var here = (t === 'home' && (/\/$|index\.html$/.test(path))) ||
               (t === 'shop' && /catalogue|collection/.test(path)) ||
               (t === 'quiz' && /\/pages\/(quiz|routine)/.test(path));
    if (here) a.setAttribute('aria-current', 'page');
  });

  /* ── catalogue: round category shortcuts press the real filter chip ────── */
  var picks = document.querySelectorAll('[data-cat-pick]');
  if (picks.length) {
    var chipFor = function (v) {
      return document.querySelector('.cat-chips .chip[data-group="cat"][data-value="' + v + '"]');
    };
    var sync = function () {
      picks.forEach(function (p) {
        var c = chipFor(p.getAttribute('data-cat-pick'));
        p.setAttribute('aria-pressed', c ? c.getAttribute('aria-pressed') : 'false');
        p.disabled = !!(c && c.disabled);
      });
    };
    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        var c = chipFor(p.getAttribute('data-cat-pick'));
        if (c && !c.disabled) c.click();
        sync();
      });
    });
    document.querySelectorAll('.cat-chips .chip[data-group="cat"]').forEach(function (c) {
      new MutationObserver(sync).observe(c, { attributes: true, attributeFilter: ['aria-pressed', 'disabled'] });
    });
    sync();
  }
})();

/* ══════════════════════════════════════════════════════════════════════════
   TRACK MY ORDER (2026-09-16)
   The order number and phone go to WhatsApp as one message the team can act on.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var AR = /^ar\b/.test(document.documentElement.lang || '');
  document.querySelectorAll('[data-track]').forEach(function (f) {
    var err = f.querySelector('[data-track-err]');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var order = (f.elements.order.value || '').replace(/[^\d]/g, '');
      var phone = (f.elements.phone.value || '').trim();
      var msg = '';
      if (!order) msg = AR ? 'أدخل رقم طلبك' : 'Enter your order number';
      else if (phone.replace(/[^\d]/g, '').length < 7) msg = AR ? 'أدخل رقم الهاتف الذي طلبت به' : 'Enter the phone number you ordered with';
      if (msg) {
        err.textContent = msg;
        err.hidden = false;
        (order ? f.elements.phone : f.elements.order).focus();
        return;
      }
      err.hidden = true;
      var text = AR
        ? 'مرحبًا Gloramous، أود الاستفسار عن طلبي رقم #' + order + '. رقم الهاتف: ' + phone
        : 'Hello Gloramous, I would like to check on my order #' + order + '. Phone: ' + phone;
      window.open('https://wa.me/' + f.getAttribute('data-wa') + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
    });
  });
})();

/* ══════════════════════════════════════════════════════════════════════════
   SKIN QUIZ (2026-09-16)
   One question at a time. Picking an answer moves on by itself; Back returns.
   The last answer submits the form, which is a plain GET to the routine page,
   so the routine builder opens with all three answers chosen.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var form = document.querySelector('[data-quiz]');
  if (!form) return;
  var qs = [].slice.call(form.querySelectorAll('[data-quiz-q]'));
  var bar = form.querySelector('[data-quiz-bar]');
  var back = form.querySelector('[data-quiz-back]');
  var go = form.querySelector('.quiz-go');
  var wait = form.querySelector('[data-quiz-wait]');
  var at = 0, timer = null;
  var MAX_PICKS = 3;
  form.classList.add('is-stepped');

  /* A question with checkboxes takes several answers, so it cannot move on by
     itself: it gets a Next button, and stops accepting picks at three. */
  var next = document.createElement('button');
  next.type = 'button';
  next.className = 'btn quiz-next';
  next.textContent = 'Next';
  go.parentNode.insertBefore(next, go);

  function multi(q) { return !!q.querySelector('input[type="checkbox"]'); }

  function show(i) {
    at = Math.max(0, Math.min(qs.length - 1, i));
    qs.forEach(function (q, k) {
      q.classList.toggle('is-on', k === at);
      q.hidden = k !== at;
    });
    if (bar) bar.style.width = ((at + 1) / qs.length * 100) + '%';
    back.hidden = at === 0;
    var picked = !!qs[at].querySelector('input:checked');
    var last = at === qs.length - 1;
    // the submit button only matters on the last question
    go.hidden = !last || !picked;
    next.hidden = last || !multi(qs[at]);
    next.disabled = !picked;
    var first = qs[at].querySelector('input:checked') || qs[at].querySelector('input');
    if (first) first.focus({ preventScroll: true });
  }

  function capPicks(q) {
    var boxes = [].slice.call(q.querySelectorAll('input[type="checkbox"]'));
    var n = boxes.filter(function (b) { return b.checked; }).length;
    boxes.forEach(function (b) {
      b.disabled = !b.checked && n >= MAX_PICKS;
      b.closest('.quiz-opt').classList.toggle('is-capped', b.disabled);
    });
    next.disabled = n === 0;
  }

  form.addEventListener('change', function (e) {
    if (e.target.matches('input[type="checkbox"]')) {
      capPicks(qs[at]);
      return;
    }
    if (!e.target.matches('input[type="radio"]')) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (at < qs.length - 1) show(at + 1);
      else if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }, 260);
  });
  next.addEventListener('click', function () { if (!next.disabled) show(at + 1); });
  back.addEventListener('click', function () { clearTimeout(timer); show(at - 1); });
  form.addEventListener('submit', function () {
    if (wait) wait.hidden = false;
    go.disabled = true;
  });
  // coming back with the Back button restores the page as it was left, mid-submit
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    if (wait) wait.hidden = true;
    go.disabled = false;
    show(at);
  });
  show(0);
})();

/* ══════════════════════════════════════════════════════════════════════════
   SKIN PROFILE, COMPARE, PROFESSIONAL REQUEST, FIND US (2026-09-16)
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var PREVIEW = !!window.GLORAMOUS_PREVIEW;
  var AR = /^ar\b/.test(document.documentElement.lang || '');
  var LABELS = {
    'blemishes': 'Breakouts and acne', 'dark-circles': 'Dark circles', 'brightening': 'Dark spots',
    'anti-aging': 'Fine lines', 'hydration': 'Dryness', 'lifting': 'Firmness and lift',
    'sensitive-skin': 'Redness and sensitivity', 'sun-protection': 'Sun protection',
    'hair-loss': 'Hair loss', 'cellulite': 'Cellulite', 'dandruff': 'Dandruff'
  };
  var t = function (s) { return window.GloramousT ? (window.GloramousT(s) || s) : s; };

  /* ── the skin profile: what the quiz or the routine builder learned ─────── */
  var SKIN_KEY = 'gloramous.skin';
  var Skin = {
    get: function () {
      try { return JSON.parse(localStorage.getItem(SKIN_KEY)) || null; } catch (e) { return null; }
    },
    set: function (p) {
      // the routine length is kept too, so the builder reopens as the quiz left it
      var old = Skin.get() || {};
      try { localStorage.setItem(SKIN_KEY, JSON.stringify({ concerns: p.concerns || [], feel: p.feel || 'balanced',
        plan: p.plan || old.plan || 'essentials' })); } catch (e) {}
    },
    clear: function () { try { localStorage.removeItem(SKIN_KEY); } catch (e) {} }
  };
  window.GloramousSkin = Skin;

  // the quiz saves its answers as it submits
  var quiz = document.querySelector('[data-quiz]');
  if (quiz) quiz.addEventListener('submit', function () {
    var cs = [].map.call(quiz.querySelectorAll('input[name="concern"]:checked'), function (i) { return i.value; });
    var f = quiz.querySelector('input[name="feel"]:checked');
    var len = quiz.querySelector('input[name="length"]:checked');
    Skin.set({ concerns: cs, feel: f ? f.value : 'balanced', plan: len && len.value === 'full' ? 'complete' : 'essentials' });
  });

  function strongTitle(s) {
    return /retinol|glycolic|salicylic|lactic|kojic|alpha hydroxy|\bpeel\b|\baha\b/i.test(s) && !/hyaluronic/i.test(s);
  }

  var profile = Skin.get();
  if (profile && profile.concerns && profile.concerns.length) {
    var want = profile.concerns;
    // a badge on every catalogue card that treats one of the saved concerns
    document.querySelectorAll('a.card[data-facets]').forEach(function (card) {
      var f = ' ' + card.getAttribute('data-facets') + ' ';
      var hit = want.some(function (c) { return f.indexOf(' ' + c + ' ') > -1; });
      if (!hit) return;
      if (profile.feel === 'sensitive' && (strongTitle(card.getAttribute('data-title') || '') || f.indexOf('peel') > -1)) return;
      var host = card.querySelector('.card-img');
      if (!host || host.querySelector('.skin-badge')) return;
      var b = document.createElement('span');
      b.className = 'skin-badge';
      b.textContent = 'Good for your skin';
      host.appendChild(b);
    });

    // the product page says which of the concerns it treats, or warns
    var info = document.querySelector('.product-info[data-tags]');
    if (info) {
      var tagset = ' ' + info.getAttribute('data-tags') + ' ';
      var matched = want.filter(function (c) { return tagset.indexOf(' ' + c + ' ') > -1; });
      var title = (info.querySelector('h1') || {}).textContent || '';
      var note = null;
      if (profile.feel === 'sensitive' && (strongTitle(title) || / (acid-peel|peel) /.test(tagset))) {
        note = document.createElement('p');
        note.className = 'skin-fit is-warn';
        note.innerHTML = '<b>' + t('You said your skin reacts easily.') + '</b> <span>' + t('This is a strong product. Patch test first, or ask us on WhatsApp.') + '</span>';
      } else if (matched.length) {
        note = document.createElement('p');
        note.className = 'skin-fit';
        note.innerHTML = '<b>' + t('Good for your skin') + '</b> ' + matched.map(function (c) {
          return '<span class="skin-chip">' + t(LABELS[c] || c) + '</span>';
        }).join('');
      }
      /* a professional product has no buy box: the note goes above its request notice */
      var anchor = info.querySelector('.buybox') || info.querySelector('.pro-notice');
      if (note && anchor) anchor.parentNode.insertBefore(note, anchor);
    }

    // catalogue and collection: a strip that filters to the saved concerns
    var cat = document.querySelector('[data-catalogue]');
    var grid = cat && cat.querySelector('[data-cat-grid]');
    if (cat && grid && !cat.querySelector('.skin-strip')) {
      var strip = document.createElement('div');
      strip.className = 'skin-strip';
      strip.innerHTML = '<span class="skin-strip-t">' + t('Your skin') + '</span>' +
        want.map(function (c) { return '<span class="skin-chip">' + t(LABELS[c] || c) + '</span>'; }).join('') +
        '<button type="button" class="skin-strip-go" data-skin-apply>' + t('Show products for my skin') + '</button>' +
        '<a class="skin-strip-edit" href="' + (PREVIEW ? 'quiz.html' : '/pages/quiz') + '">' + t('Change answers') + '</a>';
      grid.parentNode.insertBefore(strip, grid);
      strip.querySelector('[data-skin-apply]').addEventListener('click', function () {
        want.forEach(function (c) {
          var chip = cat.querySelector('.chip[data-group="concern"][data-value="' + c + '"]');
          if (chip && chip.getAttribute('aria-pressed') !== 'true' && !chip.disabled) chip.click();
        });
        grid.scrollIntoView({ block: 'start' });
      });
    }
  }

  /* ── compare up to three products ──────────────────────────────────────── */
  var cards = document.querySelectorAll('[data-cat-grid] a.card');
  if (cards.length) {
    var CMP_KEY = 'gloramous.compare';
    var MAX = 3;
    var load = function () { try { return JSON.parse(sessionStorage.getItem(CMP_KEY)) || []; } catch (e) { return []; } };
    var save = function (l) { try { sessionStorage.setItem(CMP_KEY, JSON.stringify(l)); } catch (e) {} };
    // a pick is the product, whichever language its card link was in
    var keyOf = function (href) { return String(href || '').split('/products/').pop().split(/[?#]/)[0]; };
    var list = load();

    var snap = function (card) {
      var img = card.querySelector('img');
      var price = card.querySelector('.card-price');
      var vol = card.querySelector('.vol');
      return { href: card.getAttribute('href'), title: card.getAttribute('data-title') || (card.querySelector('h2,h3') || {}).textContent,
               img: img ? img.getAttribute('src') : '', price: price ? price.textContent.trim() : '',
               priceHtml: price ? price.innerHTML.trim() : '', lang: (document.documentElement.lang || '').split('-')[0],
               size: vol ? vol.textContent.trim() : '', unit: parseInt(card.getAttribute('data-unit') || '0', 10),
               facets: card.getAttribute('data-facets') || '' };
    };

    var tray = document.createElement('div');
    tray.className = 'cmp-tray';
    tray.hidden = true;
    tray.innerHTML = '<div class="cmp-tray-in"><div class="cmp-thumbs" data-cmp-thumbs></div>' +
      '<p class="cmp-hint" data-cmp-hint></p>' +
      '<button type="button" class="btn" data-cmp-open>Compare</button>' +
      '<button type="button" class="cmp-clear" data-cmp-clear>Clear</button></div>';
    document.body.appendChild(tray);

    var dlg = document.createElement('dialog');
    dlg.className = 'cmp-dlg';
    dlg.setAttribute('aria-labelledby', 'cmp-h');
    document.body.appendChild(dlg);

    var paint = function () {
      document.querySelectorAll('[data-cmp-toggle]').forEach(function (b) {
        var on = list.some(function (x) { return keyOf(x.href) === keyOf(b.getAttribute('data-cmp-toggle')); });
        b.setAttribute('aria-pressed', String(on));
        b.querySelector('span').textContent = on ? t('Comparing') : t('Compare');
      });
      tray.hidden = !list.length;
      document.body.classList.toggle('has-cmp', list.length > 0);
      tray.querySelector('[data-cmp-thumbs]').innerHTML = list.map(function (x) {
        return '<span class="cmp-thumb"><img src="' + x.img + '" alt="" width="44" height="44"></span>';
      }).join('');
      var open = tray.querySelector('[data-cmp-open]');
      open.disabled = list.length < 2;
      open.textContent = t('Compare') + ' (' + list.length + ')';
      tray.querySelector('[data-cmp-hint]').textContent = list.length < 2 ? t('Pick one more to compare') : '';
    };

    cards.forEach(function (card) {
      var host = card.querySelector('.card-img');
      if (!host || host.querySelector('[data-cmp-toggle]')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cmp-toggle';
      b.setAttribute('data-cmp-toggle', card.getAttribute('href'));
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M9 4v16M15 4v16M4 9h5M15 15h5"/></svg><span>Compare</span>';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var href = card.getAttribute('href');
        var at = list.findIndex(function (x) { return keyOf(x.href) === keyOf(href); });
        if (at > -1) list.splice(at, 1);
        else if (list.length < MAX) list.push(snap(card));
        else { tray.querySelector('[data-cmp-hint]').textContent = t('You can compare up to 3 products'); return; }
        save(list); paint();
      });
      host.appendChild(b);
    });

    var row = function (label, cells) {
      return '<tr><th scope="row">' + t(label) + '</th>' + cells.map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>';
    };
    tray.querySelector('[data-cmp-open]').addEventListener('click', function () {
      if (list.length < 2) return;
      var concernsOf = function (x) {
        return x.facets.split(' ').filter(function (f) { return LABELS[f]; }).map(function (f) { return t(LABELS[f]); }).join(AR ? '، ' : ', ') || '—';
      };
      var perHundred = function (x) { return x.unit ? '$' + (x.unit / 100).toFixed(2) : '—'; };
      var cheapest = Math.min.apply(null, list.map(function (x) { return x.unit || Infinity; }));
      dlg.innerHTML = '<div class="cmp-in"><div class="cmp-top"><h2 id="cmp-h">' + t('Compare products') + '</h2>' +
        '<button type="button" class="cmp-x" data-cmp-close aria-label="' + t('Close') + '">&times;</button></div>' +
        '<div class="cmp-scroll" tabindex="0" role="region" aria-label="' + t('Comparison') + '"><table class="cmp-table"><thead><tr><td></td>' +
        list.map(function (x) {
          return '<th scope="col"><a href="' + x.href + '" data-l10n-handle="' + keyOf(x.href) + '" data-l10n-lang="' + (x.lang || '') +
            '"><img src="' + x.img + '" alt="" width="120" height="120"><span data-l10n-name>' + x.title + '</span></a></th>';
        }).join('') + '</tr></thead><tbody>' +
        row('Price', list.map(function (x) { return '<b class="cmp-price">' + (x.priceHtml || x.price) + '</b>'; })) +
        row('Size', list.map(function (x) { return x.size || '—'; })) +
        row('Price per 100 mL', list.map(function (x) {
          return perHundred(x) + (x.unit && x.unit === cheapest ? ' <span class="cmp-best">' + t('Best value') + '</span>' : '');
        })) +
        row('Good for', list.map(concernsOf)) +
        row('Strength', list.map(function (x) { return strongTitle(x.title) ? t('Strong: evenings, not for sensitive skin') : t('Gentle, daily use'); })) +
        '</tbody><tfoot><tr><td></td>' + list.map(function (x) {
          return '<td><a class="btn btn--small" href="' + x.href + '" data-l10n-handle="' + keyOf(x.href) + '">' + t('View product') + '</a></td>';
        }).join('') + '</tr></tfoot></table></div></div>';
      if (window.GloramousLocalise) window.GloramousLocalise(dlg);
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || (e.target.closest && e.target.closest('[data-cmp-close]'))) dlg.close();
    });
    tray.querySelector('[data-cmp-clear]').addEventListener('click', function () { list = []; save(list); paint(); });
    paint();
  }

  /* ── professional request ─────────────────────────────────────────────── */
  var pro = document.querySelector('[data-pro]');
  if (pro) {
    var err = pro.querySelector('[data-pro-err]');
    var val = function (n) { var el = pro.querySelector('[name="' + n + '"]'); return el ? el.value.trim() : ''; };
    var check = function () {
      var missing = ['contact[Business]', 'contact[name]', 'contact[City]', 'contact[phone]'].filter(function (n) { return !val(n); });
      if (missing.length) {
        err.textContent = t('Fill in your business name, your name, city and phone.');
        err.hidden = false;
        pro.querySelector('[name="' + missing[0] + '"]').focus();
        return false;
      }
      err.hidden = true;
      return true;
    };
    var message = function () {
      var wants = [].map.call(pro.querySelectorAll('input[type="checkbox"]:checked'), function (i) { return i.value; });
      return [AR ? 'مرحبًا Gloramous، أود فتح حساب مهني.' : 'Hello Gloramous, I would like to open a professional account.', '',
        'Business: ' + val('contact[Business]'), 'Name: ' + val('contact[name]'), 'Type: ' + val('contact[Type]'),
        'City: ' + val('contact[City]'), 'Phone: ' + val('contact[phone]'),
        val('contact[email]') ? 'Email: ' + val('contact[email]') : '',
        wants.length ? 'Interested in: ' + wants.join(', ') : '',
        val('contact[Products]') ? 'Products: ' + val('contact[Products]') : '',
        val('contact[body]') ? 'Notes: ' + val('contact[body]') : ''].filter(function (l, i) { return l || i === 1; }).join('\n');
    };
    var waBtn = pro.querySelector('[data-pro-wa]');
    if (waBtn) waBtn.addEventListener('click', function () {
      if (!check()) return;
      window.open('https://wa.me/' + waBtn.getAttribute('data-pro-wa') + '?text=' + encodeURIComponent(message()), '_blank', 'noopener');
    });
    pro.addEventListener('submit', function (e) {
      if (!check()) { e.preventDefault(); return; }
      if (PREVIEW) {
        e.preventDefault();
        var ok = document.createElement('p');
        ok.className = 'pro-ok';
        ok.setAttribute('role', 'status');
        ok.textContent = t('Thank you. We will be in touch within two working days.');
        pro.replaceWith(ok);
      }
    });
  }

  /* ── find us: the map follows the chosen place; Directions opens the
        visitor's own map app ────────────────────────────────────────────── */
  var locs = document.querySelectorAll('[data-loc]');
  if (locs.length) {
    var map = document.querySelector('[data-loc-map]');
    var ua = navigator.userAgent || '';
    var ios = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    var android = /Android/i.test(ua);
    locs.forEach(function (li) {
      var lat = li.getAttribute('data-lat'), lng = li.getAttribute('data-lng'), name = li.getAttribute('data-name');
      var go = li.querySelector('[data-loc-go]');
      if (go && ios) go.href = 'https://maps.apple.com/?daddr=' + lat + ',' + lng + '&q=' + encodeURIComponent(name);
      else if (go && android) { go.href = 'geo:' + lat + ',' + lng + '?q=' + lat + ',' + lng + '(' + encodeURIComponent(name) + ')'; go.removeAttribute('target'); }
      var pick = li.querySelector('[data-loc-pick]');
      if (pick) pick.addEventListener('click', function () {
        locs.forEach(function (o) {
          o.classList.toggle('is-on', o === li);
          var p = o.querySelector('[data-loc-pick]');
          if (p) p.setAttribute('aria-pressed', String(o === li));
        });
        if (map) map.src = 'https://maps.google.com/maps?q=' + lat + ',' + lng + '&z=16&output=embed';
        if (window.matchMedia('(max-width:859px)').matches && map) map.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    });
  }
})();

/* ══════════════════════════════════════════════════════════════════════════
   ROUND 12 (2026-09-17): reorder reminder, before/after, holiday banners,
   Arabic search words
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var AR = /^ar\b/.test(document.documentElement.lang || '');
  var t = function (s) { return window.GloramousT ? (window.GloramousT(s) || s) : s; };

  /* ── Arabic words a shopper might type, mapped to the catalogue's own words.
        The catalogue is tagged in English; without this, typing حب الشباب
        found nothing at all. Used by the header search and the catalogue. */
  var AR_WORDS = [
    ['حب الشباب', 'blemishes'], ['حبوب', 'blemishes'], ['بثور', 'blemishes'], ['شوائب', 'blemishes'],
    ['تفتيح', 'brightening'], ['بقع', 'brightening'], ['تصبغ', 'brightening'], ['كلف', 'brightening'], ['نضارة', 'brightening'],
    ['تجاعيد', 'anti-aging'], ['خطوط', 'anti-aging'], ['شيخوخة', 'anti-aging'], ['ترطيب', 'hydration'], ['جفاف', 'hydration'],
    ['هالات', 'dark circles'], ['تحت العين', 'eye'], ['عين', 'eye'], ['عيون', 'eye'], ['شد', 'lifting'], ['ترهل', 'lifting'],
    ['حساس', 'sensitive'], ['احمرار', 'sensitive'], ['شمس', 'sun'], ['واقي', 'sun'], ['واقي شمس', 'sunscreen'],
    ['شعر', 'hair'], ['تساقط', 'hair loss'], ['قشرة', 'dandruff'], ['جسم', 'body'], ['سيلوليت', 'cellulite'],
    ['سيروم', 'serum'], ['كريم', 'cream'], ['غسول', 'wash'], ['منظف', 'cleanser'], ['تونر', 'toner'], ['قناع', 'mask'], ['ماسك', 'mask'],
    ['مقشر', 'scrub'], ['تقشير', 'peel'], ['زيت', 'oil'], ['عطر', 'perfume'], ['رجال', 'men'], ['لحية', 'beard'], ['شفاه', 'lip'],
    ['حمض', 'acid'], ['فيتامين سي', 'vitamin c'], ['فيتامين', 'vitamin'], ['كولاجين', 'collagen'], ['هيالورونيك', 'hyaluronic'],
    ['حلزون', 'snail'], ['زعفران', 'saffron'], ['ذهب', 'gold'], ['كافيار', 'caviar'], ['ريتينول', 'retinol'], ['نياسيناميد', 'niacinamide'],
    ['قهوة', 'coffee'], ['زيتون', 'olive'], ['خلايا جذعية', 'stem cells'], ['بوتوكس', 'botox'], ['ميزو', 'meso'], ['أمبول', 'ampoule']
  ];
  // one spelling for searching: no vowel marks or stretch line, one alef, ة = ه, ى = ي
  function anorm(s) {
    return String(s || '').toLowerCase().replace(/[\u064B-\u065F\u0670\u0640]/g, '')
      .replace(/[\u0623\u0625\u0622]/g, '\u0627').replace(/\u0629/g, '\u0647').replace(/\u0649/g, '\u064A')
      .replace(/\s+/g, ' ').trim();
  }
  window.GloramousNorm = anorm;
  function expand(q) {
    q = anorm(q);
    if (!q || !/[؀-ۿ]/.test(q)) return q ? [q] : [];
    var out = [];
    AR_WORDS.sort(function (a, b) { return b[0].length - a[0].length; }).forEach(function (w) {
      if (q.indexOf(anorm(w[0])) > -1 && out.indexOf(w[1]) === -1) out.push(w[1]);
    });
    return out.length ? out : [q];
  }
  window.GloramousSearchTerms = expand;

  /* ── reorder reminder: an event in the shopper's own calendar ──────────── */
  document.querySelectorAll('[data-lasts]').forEach(function (box) {
    var btn = box.querySelector('[data-remind]');
    var menu = box.querySelector('[data-remind-menu]');
    if (!btn || !menu) return;
    var weeks = parseInt(box.getAttribute('data-weeks'), 10) || 4;
    var name = box.getAttribute('data-name') || '';
    var url = box.getAttribute('data-url') || location.href;
    // a week before it should run out, at 10:00
    var when = new Date();
    when.setDate(when.getDate() + Math.max(1, weeks - 1) * 7);
    when.setHours(10, 0, 0, 0);
    var end = new Date(when.getTime() + 30 * 60000);
    var stamp = function (d) {
      return d.getFullYear() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0') +
        'T' + String(d.getHours()).padStart(2, '0') + String(d.getMinutes()).padStart(2, '0') + '00';
    };
    var title = (AR ? 'أعد طلب ' : 'Reorder ') + name;
    var details = (AR ? 'قد يقترب ' + name + ' من النفاد. اطلبه مجددًا: ' : 'Your ' + name + ' is probably running low. Order again: ') + url;
    btn.addEventListener('click', function () {
      var open = menu.hidden;
      menu.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
    });
    menu.querySelector('[data-remind-google]').href =
      'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(title) +
      '&dates=' + stamp(when) + '/' + stamp(end) + '&details=' + encodeURIComponent(details);
    menu.querySelector('[data-remind-ics]').addEventListener('click', function (e) {
      e.preventDefault();
      var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Gloramous//Reorder//EN', 'BEGIN:VEVENT',
        'UID:' + Date.now() + '@gloramous', 'DTSTAMP:' + stamp(new Date()),
        'DTSTART:' + stamp(when), 'DTEND:' + stamp(end), 'SUMMARY:' + title.replace(/[,;]/g, ' '),
        'DESCRIPTION:' + details.replace(/[,;]/g, ' '), 'URL:' + url,
        'BEGIN:VALARM', 'TRIGGER:-PT0M', 'ACTION:DISPLAY', 'DESCRIPTION:' + title.replace(/[,;]/g, ' '), 'END:VALARM',
        'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
      var blob = new Blob([ics], { type: 'text/calendar' });
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'reorder-' + name.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.ics';
      document.body.appendChild(a);
      a.click();
      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = t('Reminder added');
    });
  });

  /* ── before and after: drag to compare ─────────────────────────────────── */
  document.querySelectorAll('[data-ba]').forEach(function (frame) {
    var r = frame.querySelector('.ba-range');
    if (!r) return;
    r.addEventListener('input', function () { frame.style.setProperty('--ba', r.value + '%'); });
  });

  /* ── holiday banner: closing it is remembered for that occasion ─────────── */
  document.querySelectorAll('[data-holiday]').forEach(function (b) {
    var key = 'gloramous.holiday.' + (b.getAttribute('data-holiday-key') || '');
    try { if (localStorage.getItem(key) === '1' && !b.closest('.banners-demo')) { b.hidden = true; return; } } catch (e) {}
    var x = b.querySelector('[data-holiday-close]');
    if (x) x.addEventListener('click', function () {
      b.hidden = true;
      try { localStorage.setItem(key, '1'); } catch (e) {}
    });
  });
})();

/* ══════════════════════════════════════════════════════════════════════════
   ROUND 13 (2026-09-17): the search advisor, the professional range request,
   the three-city Find us, the phone header, calm scroll design, and the
   technical layer (events, offline, delivery details)
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var PREVIEW = !!window.GLORAMOUS_PREVIEW;
  var AR = /^ar\b/.test(document.documentElement.lang || '');
  var CALM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var T = function (s) { return window.GloramousT ? (window.GloramousT(s) || s) : s; };
  var URLS = window.GLORAMOUS_URLS || (PREVIEW
    ? { index: 'search-index.json', routine: 'routine.html', catalogue: 'catalogue.html' }
    : { index: '/collections/all?view=search-index', routine: '/pages/routine', catalogue: '/pages/catalogue' });
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(c) { var v = (c || 0) / 100; return '$' + (v % 1 ? v.toFixed(2) : String(v)); }

  /* ── events: one call for every measurement tool ─────────────────────────
     Shopify's Customer events (Settings > Customer events) receive these as
     custom events, so a Meta Pixel or Google Analytics pixel added there can
     count them. Nothing is sent anywhere by this function on its own. */
  var track = window.GloramousTrack = function (name, data) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'gloramous_' + name, gloramous: data }); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('gloramous_' + name, data); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('gloramous:track', { detail: { name: name, data: data } })); } catch (e) {}
  };

  /* ══ 1. THE SEARCH ADVISOR ════════════════════════════════════════════════
     The search box understands a skin need ("dry skin", "acne", "بقع") as well
     as a product or ingredient name. For a need it shows three products from
     the range that are for that need, in the order they are used, with one
     button to add them all. Everything else is ranked: name first, then what
     the product is for, then its ingredients, with one typo forgiven. */
  var NEEDS = [
    { c: 'blemishes', w: ['acne', 'pimple', 'pimples', 'breakout', 'breakouts', 'blackhead', 'blackheads', 'whitehead', 'whiteheads', 'oily skin', 'oily', 'greasy', 'pores', 'blemish', 'blemishes', 'حب الشباب', 'حبوب', 'بثور', 'رؤوس سوداء', 'بشرة دهنية', 'دهنية', 'مسام', 'شوائب'] },
    { c: 'hydration', w: ['dry skin', 'dry', 'dehydrated', 'dryness', 'tight skin', 'flaky', 'hydration', 'hydrating', 'moisture', 'بشرة جافة', 'جافة', 'جفاف', 'ترطيب'] },
    { c: 'anti-aging', w: ['wrinkles', 'wrinkle', 'fine lines', 'lines', 'aging', 'ageing', 'anti aging', 'anti-aging', 'mature skin', 'تجاعيد', 'خطوط', 'شيخوخة'] },
    { c: 'brightening', w: ['dark spots', 'dark spot', 'pigmentation', 'hyperpigmentation', 'melasma', 'dull', 'dull skin', 'uneven', 'uneven tone', 'glow', 'whitening', 'brightening', 'بقع', 'تصبغ', 'تصبغات', 'كلف', 'تفتيح', 'نضارة', 'بشرة باهتة'] },
    { c: 'lifting', w: ['sagging', 'firming', 'firm', 'lifting', 'lift', 'loose skin', 'ترهل', 'شد'] },
    { c: 'sensitive skin', w: ['sensitive skin', 'sensitive', 'redness', 'irritation', 'irritated', 'rosacea', 'بشرة حساسة', 'حساسة', 'حساس', 'احمرار', 'تهيج'] },
    { c: 'dark circles', w: ['dark circles', 'eye bags', 'puffy eyes', 'under eye', 'under-eye', 'هالات', 'هالات سوداء', 'انتفاخ العين'] },
    { c: 'sun protection', w: ['sunscreen', 'sun screen', 'spf', 'sunblock', 'sun block', 'sunburn', 'sun protection', 'واقي شمس', 'واقي الشمس', 'واقي'] },
    { c: 'hair loss', w: ['hair loss', 'hair fall', 'thinning hair', 'losing hair', 'تساقط الشعر', 'تساقط'] },
    { c: 'dandruff', w: ['dandruff', 'itchy scalp', 'flaky scalp', 'قشرة'] },
    { c: 'cellulite', w: ['cellulite', 'orange peel skin', 'سيلوليت'] }
  ];
  var FACE = ['blemishes', 'hydration', 'anti-aging', 'brightening', 'lifting', 'sensitive skin'];
  var POPULAR = AR
    ? ['حب الشباب', 'بشرة جافة', 'بقع', 'تجاعيد', 'بشرة حساسة', 'هالات سوداء', 'تساقط الشعر', 'واقي شمس']
    : ['Acne', 'Dry skin', 'Dark spots', 'Wrinkles', 'Sensitive skin', 'Dark circles', 'Hair loss', 'Sunscreen'];

  function norm(q) { return String(q || '').toLowerCase().replace(/[ً-ْ]/g, '').replace(/\s+/g, ' ').trim(); }
  function needOf(q) {
    q = norm(q);
    if (!q) return null;
    var best = null;
    NEEDS.forEach(function (n) {
      n.w.forEach(function (w) {
        var re = /[؀-ۿ]/.test(w) ? null : new RegExp('(^|[^a-z])' + w.replace(/[-]/g, '\\-') + '([^a-z]|$)');
        var hit = re ? re.test(q) : q.indexOf(w) > -1;
        if (hit && (!best || w.length > best.w.length)) best = { c: n.c, w: w };
      });
    });
    return best;
  }

  var indexP = null;
  function loadIndex() {
    if (!indexP) {
      // no Accept: application/json header here: Shopify answers a collection
      // ?view= request that asks for JSON with a 404; the template already is JSON
      indexP = fetch(URLS.index, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('index'); return r.json(); })
        .then(function (j) { return (j.results || j).filter(function (r) { return r && r.title; }); })
        .catch(function (e) { indexP = null; throw e; });
    }
    return indexP;
  }

  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  function wordsOf(r) {
    if (!r._w) r._w = norm(r.title + ' ' + (r.ing || '') + ' ' + (r.form || '')).split(/[^a-z0-9؀-ۿ]+/).filter(function (w) { return w.length > 2; });
    return r._w;
  }
  function scoreToken(r, tok) {
    var title = norm(r.title), hay = norm(r.hay || ''), ing = norm(r.ing || '');
    var conc = (r.concerns || []).join(' ');
    if (title.indexOf(tok) === 0) return 12;
    if (new RegExp('(^|\\s)' + tok.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).test(title)) return 10;
    if (title.indexOf(tok) > -1) return 8;
    if (conc.indexOf(tok) > -1) return 7;
    if ((r.form || '') === tok || norm(r.type).indexOf(tok) > -1) return 6;
    if (ing.indexOf(tok) > -1) return 5;
    if (hay.indexOf(tok) > -1) return 3;
    if (tok.length >= 4 && !/[؀-ۿ]/.test(tok)) {
      var max = tok.length >= 7 ? 2 : 1;
      var ws = wordsOf(r);
      for (var i = 0; i < ws.length; i++) if (lev(tok, ws[i], max) <= max) return 2;
    }
    return 0;
  }
  function rank(list, q) {
    var qn = norm(q);
    var groups, optional = [];
    if (/[؀-ۿ]/.test(qn) && window.GloramousSearchTerms) {
      groups = [window.GloramousSearchTerms(qn).concat([qn])];               // Arabic: any mapped word
    } else {
      var toks = qn.split(' ').filter(function (t) { return ['for', 'and', 'the', 'with', 'my', 'skin'].indexOf(t) < 0; });
      optional = toks.filter(function (t) { return t.length === 1; });   // "vitamin c": the c helps, it is not required
      groups = toks.filter(function (t) { return t.length > 1; }).map(function (t) { return [t]; });
      if (!groups.length) groups = [[qn]];
    }
    var out = [];
    list.forEach(function (r) {
      var total = 0;
      for (var g = 0; g < groups.length; g++) {
        var best = 0;
        groups[g].forEach(function (t) { best = Math.max(best, scoreToken(r, norm(t))); });
        if (!best) return;                                         // every word has to match something
        total += best;
      }
      var tw = ' ' + norm(r.title) + ' ';
      optional.forEach(function (t) { if (tw.indexOf(' ' + t + ' ') > -1) total += 6; });
      if (norm(r.title) === qn) total += 20;
      if (r.locked) total -= 4;
      out.push({ r: r, s: total });
    });
    return out.sort(function (a, b) { return b.s - a.s || a.r.title.localeCompare(b.r.title); }).map(function (x) { return x.r; });
  }

  /* one typo per word: "vitamn" is read as "vitamin", "hyaluronc" as "hyaluronic" */
  var vocab = null;
  function correct(list, q) {
    var qn = norm(q);
    if (/[؀-ۿ]/.test(qn)) return qn;
    if (!vocab) {
      var seen = {};
      list.forEach(function (r) { wordsOf(r).forEach(function (w) { if (w.length > 2) seen[w] = 1; }); });
      NEEDS.forEach(function (n) { n.w.forEach(function (w) { if (!/[؀-ۿ]/.test(w)) w.split(' ').forEach(function (x) { if (x.length > 2) seen[x] = 1; }); }); });
      vocab = Object.keys(seen);
    }
    return qn.split(' ').map(function (t) {
      if (t.length < 4) return t;
      if (vocab.some(function (w) { return w.indexOf(t) > -1; })) return t;
      var max = t.length >= 7 ? 2 : 1, best = t, bd = max + 1;
      vocab.forEach(function (w) { var d = lev(t, w, max); if (d < bd) { bd = d; best = w; } });
      return best;
    }).join(' ');
  }
  function didYouMean(list, q) {
    var c = correct(list, q);
    return c !== norm(q) ? c : '';
  }

  var NOT_FACE = /\b(body|hand|hands|hair|lip|lips|foot|feet|beard|scalp)\b/i;
  function needWords(c) {
    var n = NEEDS.filter(function (x) { return x.c === c; })[0];
    return n ? n.w.filter(function (w) { return !/[؀-ۿ]/.test(w); }) : [];
  }
  function needSort(c) {
    var words = needWords(c);
    return function (a, b) {
      var ta = words.some(function (w) { return norm(a.title).indexOf(w) > -1; }) ? 0 : 1;
      var tb = words.some(function (w) { return norm(b.title).indexOf(w) > -1; }) ? 0 : 1;
      return (a.locked ? 1 : 0) - (b.locked ? 1 : 0) || ta - tb ||
        ((a.single === false) ? 1 : 0) - ((b.single === false) ? 1 : 0) ||
        ((a.concerns || []).length - (b.concerns || []).length) || (a.price - b.price);
    };
  }
  function isFace(r) { return !NOT_FACE.test(r.title) && /(^|\s)face(\s|$)/.test(r.hay || ''); }
  function forNeed(list, c) {
    var face = FACE.indexOf(c) > -1;
    return list.filter(function (r) {
      if (r.locked || !(r.price > 0) || (r.concerns || []).indexOf(c) < 0) return false;
      return !face || isFace(r);
    }).sort(needSort(c));
  }
  function pick(cands, forms, not) {
    for (var i = 0; i < cands.length; i++) {
      if (forms.indexOf(cands[i].form) > -1 && not.indexOf(cands[i]) < 0) return cands[i];
    }
    return null;
  }
  function routineFor(list, c) {
    var cands = forNeed(list, c), steps = [], used = [];
    var add = function (label, r) { if (r && used.indexOf(r) < 0) { steps.push({ step: label, r: r }); used.push(r); } };
    var faceOk = function (r) { return !r.locked && r.price > 0 && isFace(r); };
    if (FACE.indexOf(c) > -1) {
      var cleansers = list.filter(function (r) { return faceOk(r) && r.form === 'cleanser'; }).sort(needSort(c));
      add('Cleanse', pick(cands, ['cleanser'], used) || cleansers[0]);
      var words = needWords(c);
      var named = cands.filter(function (r) { return r.form !== 'cleanser' && words.some(function (w) { return norm(r.title).indexOf(w) > -1; }); })[0];
      add('Treat', named || pick(cands, ['serum', 'ampoule'], used) || pick(cands, ['cream', 'gel', 'oil'], used));
      if (['blemishes', 'brightening', 'anti-aging'].indexOf(c) > -1) {
        var sun = list.filter(function (r) { return faceOk(r) && (r.concerns || []).indexOf('sun protection') > -1 && !/oil|spray|kids|children|pediatric/i.test(r.title); })
          .sort(function (a, b) { return ((a.single === false) ? 1 : 0) - ((b.single === false) ? 1 : 0) || a.price - b.price; });
        add('Protect', sun[0]);
      }
      if (steps.length < 3) add('Moisturise', pick(cands, ['cream', 'gel', 'balm', 'lotion'], used));
    } else if (c === 'dark circles') {
      add('Treat', pick(cands, ['serum', 'gel', 'ampoule'], used));
      add('Care', pick(cands, ['cream', 'balm', 'oil'], used));
    } else if (c === 'hair loss' || c === 'dandruff') {
      add('Wash', pick(cands, ['shampoo'], used));
      add('Treat', pick(cands, ['lotion', 'serum', 'spray', 'oil', 'ampoule'], used));
    }
    cands.forEach(function (r) { if (steps.length < 3 && used.indexOf(r) < 0) add(c === 'sun protection' ? 'Protect' : 'Care', r); });
    return { steps: steps.slice(0, 3), count: list.filter(function (r) { return !r.locked && (r.concerns || []).indexOf(c) > -1; }).length };
  }
  function slug(c) { return c.replace(/\s+/g, '-'); }

  function adviceHtml(list, need, q) {
    var plan = routineFor(list, need.c);
    if (!plan.steps.length) return '';
    var total = plan.steps.reduce(function (a, s) { return a + s.r.price; }, 0);
    var lines = plan.steps.map(function (s) {
      return { id: s.r.id, title: s.r.title, price: s.r.price, image: s.r.image, variant: s.r.size === 'Default Title' ? '' : (s.r.size || '') };
    }).filter(function (l) { return l.id; });
    var rows = plan.steps.map(function (s, i) {
      var img = s.r.image ? '<img src="' + esc(s.r.image) + '" alt="" width="52" height="52" loading="lazy">' : '<span class="fam-ph">&middot;</span>';
      return '<li><a class="adv-row" href="' + esc(s.r.url) + '"><span class="adv-img">' + img + '</span>' +
        '<span class="adv-t"><span class="adv-step">' + esc(T(s.step)) + '</span><b>' + esc(s.r.title) + '</b></span>' +
        '<span class="adv-price">' + money(s.r.price) + '</span></a></li>';
    }).join('');
    var head = AR ? 'مختار لـ«' + esc(q) + '»' : 'Picked for “' + esc(q) + '”';
    var canAdd = lines.length === plan.steps.length && plan.steps.every(function (s) { return s.r.single !== false; });
    return '<div class="adv" data-adv>' +
      '<div class="adv-head"><b>' + head + '</b><span>' + esc(T('Products from the range made for this, in the order you use them.')) + '</span></div>' +
      '<ol class="adv-steps" role="list">' + rows + '</ol>' +
      '<div class="adv-actions">' +
      (canAdd ? '<button class="btn adv-add" type="button" data-adv-add="' + esc(JSON.stringify(lines)) + '">' +
        esc(AR ? 'أضف الكل (' + plan.steps.length + ')، ' + money(total) : 'Add all ' + plan.steps.length + ', ' + money(total)) + '</button>' : '') +
      /* only the seven face concerns routine.js builds for; hair loss, dandruff,
         cellulite and sun protection opened the builder with nothing chosen */
      (['blemishes', 'brightening', 'anti-aging', 'hydration', 'dark-circles', 'lifting', 'sensitive-skin'].indexOf(slug(need.c)) > -1
        ? '<a class="adv-link" href="' + esc(URLS.routine + '?concern=' + slug(need.c)) + '">' + esc(T('Build the full routine')) + '</a>' : '') +
      '<a class="adv-link" href="' + esc(URLS.catalogue + '?concern=' + slug(need.c)) + '">' + esc(AR ? 'كل المنتجات (' + plan.count + ')' : 'See all ' + plan.count) + '</a>' +
      '</div></div>';
  }

  function addLines(btn, lines) {
    if (!lines.length || !window.GloramousCart) return;
    var label = btn.textContent;
    btn.disabled = true;
    var done = function () {
      btn.textContent = T('Added');
      track('advisor_add_all', { count: lines.length });
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600);
    };
    var fail = function () { btn.disabled = false; btn.textContent = T('Could not add, try again'); };
    if (PREVIEW) {
      var p = window.GloramousCart.addMany(lines);
      (p && p.then ? p : Promise.resolve()).then(done, fail);
      return;
    }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map(function (l) { return { id: l.id, quantity: 1 }; }) })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return window.GloramousCart.open(lines.length + ' products added'); })
      .then(done, fail);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-adv-add]');
    if (!b) return;
    e.preventDefault();
    var lines;
    try { lines = JSON.parse(b.getAttribute('data-adv-add')); } catch (err) { return; }
    addLines(b, lines);
  });

  /* the header panel asks this; cart-drawer.js renders the rows */
  window.GloramousAdvisor = {
    needOf: needOf,
    search: function (q) {
      return loadIndex().then(function (list) {
        var need = needOf(q);
        var hits = rank(list, q);
        var fixed = '';
        if (!need) {
          var c = didYouMean(list, q);
          if (c) { var h2 = rank(list, c); if (h2.length) { fixed = c; need = needOf(c); hits = h2; } }
        }
        var advice = '';
        if (need) {
          advice = adviceHtml(list, need, fixed || q);
          var srt = needSort(need.c), faceNeed = FACE.indexOf(need.c) > -1;
          var byNeed = list.filter(function (r) { return (r.concerns || []).indexOf(need.c) > -1; }).sort(function (a, b) {
            return faceNeed ? ((isFace(a) ? 0 : 1) - (isFace(b) ? 0 : 1) || srt(a, b)) : srt(a, b);
          });
          hits = byNeed.concat(hits.filter(function (r) { return byNeed.indexOf(r) < 0; }));
        }
        if (fixed) {
          advice = '<p class="sres-fixed">' + esc(AR ? 'نتائج لـ«' + fixed + '»' : 'Showing results for “' + fixed + '”') + '</p>' + advice;
        }
        track('search', { q: q, need: need ? need.c : '', results: hits.length });
        return { list: hits.slice(0, 8), advice: advice, need: need, suggest: '' };
      });
    },
    popular: POPULAR
  };

  /* catalogue and search pages: the same advice above the grid when the
     query is a skin need */
  (function () {
    var q = '';
    try { q = new URLSearchParams(location.search).get('q') || ''; } catch (e) {}
    var need = needOf(q);
    if (!need) return;
    var host = document.querySelector('[data-cat-grid]') || document.querySelector('main .catalogue .grid');
    var form = document.querySelector('.searchform--page');
    if (!host && form) host = form.nextElementSibling;
    if (!host) return;
    loadIndex().then(function (list) {
      var html = adviceHtml(list, need, q);
      if (!html) return;
      var box = document.createElement('div');
      box.className = 'adv-page';
      box.innerHTML = html;
      host.parentNode.insertBefore(box, host);
    }).catch(function () {});
  })();

  /* catalogue filter words: "dry skin" filters to hydration, "acne" to blemishes */
  var baseTerms = window.GloramousSearchTerms;
  if (baseTerms) {
    window.GloramousSearchTerms = function (q) {
      var n = needOf(q);
      return n ? [n.c] : baseTerms(q);
    };
    /* the catalogue filtered on load, before this existed: filter again */
    var catQ = document.querySelector('[data-cat-search]');
    if (catQ && catQ.value && needOf(catQ.value)) catQ.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ══ 2. PHONE HEADER: a real search bar that opens the search ═════════════ */
  document.querySelectorAll('[data-search-open-m]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      var o = document.querySelector('[data-search-open]');
      if (o) o.click();
      track('search_open', { from: 'phone_bar' });
    });
  });

  /* ══ 3. PROFESSIONAL RANGE: a request list that fills the form ═══════════ */
  (function () {
    var range = document.querySelector('[data-pro-range]');
    if (!range) return;
    var KEY = 'gloramous.prorequest';
    var bar = range.querySelector('[data-pro-bar]');
    var n = range.querySelector('[data-pro-bar-n]');
    if (bar) document.body.appendChild(bar);   // above the footer, like the product buy bar
    var form = document.querySelector('[data-pro]');
    var field = form && form.querySelector('[data-pro-products]');
    var shown = form && form.querySelector('[data-pro-selected]');
    var chosen = [];
    try { chosen = JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) {}
    // kept by product (handle:variant), shown by this page's name for it, so the
    // list survives a language switch; old name-based lists are converted here
    var keyOfLi = function (li) { return li.getAttribute('data-pro-key') || li.getAttribute('data-pro-item'); };
    var labelOf = {}, keyOfLabel = {};
    range.querySelectorAll('[data-pro-item]').forEach(function (li) {
      labelOf[keyOfLi(li)] = li.getAttribute('data-pro-item');
      keyOfLabel[li.getAttribute('data-pro-item')] = keyOfLi(li);
    });
    chosen = chosen.map(function (x) { return labelOf[x] ? x : keyOfLabel[x]; })
      .filter(function (x, i, a) { return x && a.indexOf(x) === i; });
    var names = function () { return chosen.map(function (k) { return labelOf[k] || k; }); };
    function sync() {
      try { localStorage.setItem(KEY, JSON.stringify(chosen)); } catch (e) {}
      range.querySelectorAll('[data-pro-item]').forEach(function (li) {
        var on = chosen.indexOf(keyOfLi(li)) > -1;
        li.classList.toggle('is-chosen', on);
        var b = li.querySelector('[data-pro-add]');
        if (b) b.setAttribute('aria-pressed', String(on));
      });
      var c = chosen.length;
      if (bar) bar.hidden = c === 0;
      if (n) n.textContent = AR ? (c === 1 ? 'منتج واحد في طلبك' : c + ' منتجات في طلبك') : c + (c === 1 ? ' product' : ' products') + ' in your request';
      if (field) field.value = names().join(', ');
      if (shown) {
        shown.hidden = c === 0;
        shown.textContent = (AR ? 'في طلبك: ' : 'In your request: ') + names().join(AR ? '، ' : ', ');
      }
    }
    range.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pro-add]');
      if (!b) return;
      var li = b.closest('[data-pro-item]'), name = li.getAttribute('data-pro-item'), k = keyOfLi(li);
      var i = chosen.indexOf(k);
      if (i > -1) chosen.splice(i, 1); else { chosen.push(k); track('pro_request_add', { product: name }); }
      sync();
    });
    function toForm() {
      var target = document.getElementById('pro-form');
      if (target) target.scrollIntoView({ behavior: CALM ? 'auto' : 'smooth', block: 'start' });
      var first = form && form.querySelector('input:not([type="hidden"])');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, CALM ? 0 : 450);
    }
    /* the request goes to WhatsApp (owner, 2026-09-19): no prices on the site */
    var waGo = bar && bar.querySelector('[data-pro-bar-wa]');
    if (waGo) waGo.addEventListener('click', function () {
      if (!chosen.length) return;
      var msg = (AR ? 'مرحبًا Gloramous، أود طلب: ' : 'Hello Gloramous, I would like to request: ') + names().join(', ') + '.';
      track('pro_request_send', { count: chosen.length });
      window.open('https://wa.me/' + waGo.getAttribute('data-pro-bar-wa') + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    });
    var custom = range.querySelector('[data-pro-custom]');
    if (custom) custom.addEventListener('click', function (e) {
      e.preventDefault();
      var cb = form && form.querySelector('[data-pro-custom-check]');
      if (cb) cb.checked = true;
      toForm();
    });
    /* the bar steps aside once the form is on screen */
    if (bar && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (x) { bar.classList.toggle('is-away', x.isIntersecting); });
      }, { threshold: 0.15 }).observe(form);
    }
    sync();
  })();

  /* ══ 4. FIND US: city buttons, city-level maps, share ═════════════════════ */
  (function () {
    var locs = [].slice.call(document.querySelectorAll('[data-loc]'));
    if (!locs.length) return;
    var map = document.querySelector('[data-loc-map]');
    var note = document.querySelector('[data-loc-mapnote]');
    var cities = [].slice.call(document.querySelectorAll('[data-loc-city]'));
    function show(key, scroll) {
      locs.forEach(function (li) {
        var on = li.getAttribute('data-loc') === key;
        li.classList.toggle('is-on', on);
        var p = li.querySelector('[data-loc-pick]');
        if (p) p.setAttribute('aria-pressed', String(on));
        if (on) {
          var exact = li.getAttribute('data-exact') === 'true';
          if (map) map.src = 'https://maps.google.com/maps?q=' + li.getAttribute('data-lat') + ',' + li.getAttribute('data-lng') +
            '&z=' + (li.getAttribute('data-zoom') || (exact ? 16 : 12)) + '&output=embed';
          if (note) note.hidden = exact;
        }
      });
      cities.forEach(function (c) {
        var on = c.getAttribute('data-loc-city') === key;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', String(on));
      });
      if (scroll && window.matchMedia('(max-width:859px)').matches && map) map.scrollIntoView({ block: 'center', behavior: CALM ? 'auto' : 'smooth' });
      track('find_us_city', { city: key });
    }
    /* capture phase, so this runs instead of the older single-zoom handler */
    locs.forEach(function (li) {
      var p = li.querySelector('[data-loc-pick]');
      if (p) p.addEventListener('click', function (e) { e.stopImmediatePropagation(); show(li.getAttribute('data-loc'), true); }, true);
      var sh = li.querySelector('[data-loc-share]');
      if (sh) sh.addEventListener('click', function () {
        /* only an exact pin is shared as coordinates; otherwise the card's own
           address search, or this page (a branch with no address yet) */
        var exact = li.getAttribute('data-exact') === 'true';
        var go = li.querySelector('a.loc-go:not(.loc-go--wa)');
        var url = exact ? 'https://www.google.com/maps/search/?api=1&query=' + li.getAttribute('data-lat') + ',' + li.getAttribute('data-lng') : (go ? go.href : location.href.split('#')[0]);
        var title = li.getAttribute('data-name') || 'Gloramous';
        if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
        var done = function () { sh.textContent = T('Link copied'); setTimeout(function () { sh.textContent = T('Share'); }, 1800); };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {}); else done();
      });
    });
    cities.forEach(function (c) {
      c.addEventListener('click', function () {
        var key = c.getAttribute('data-loc-city');
        show(key, false);
        var li = locs.filter(function (l) { return l.getAttribute('data-loc') === key; })[0];
        if (li && window.matchMedia('(max-width:859px)').matches) li.scrollIntoView({ block: 'nearest', behavior: CALM ? 'auto' : 'smooth' });
      });
    });
    /* with city buttons, only the chosen city's card shows, the map right under it */
    var sec = locs[0].closest('.findus');
    if (sec && cities.length) sec.classList.add('is-single');
    document.addEventListener('shopify:block:select', function (e) {
      if (locs.some(function (l) { return l.getAttribute('data-loc') === e.detail.blockId; })) show(e.detail.blockId, false);
    });
    var first = locs.filter(function (l) { return l.classList.contains('is-on'); })[0] || locs[0];
    if (note && first) note.hidden = first.getAttribute('data-exact') === 'true';
  })();

  /* ══ 5. DESIGN: calm scroll ═══════════════════════════════════════════════ */

  /* 5a. scroll story: the picture beside the text follows the step you are
     reading. Crossfade only; the page itself never moves. */
  document.querySelectorAll('[data-story]').forEach(function (story) {
    var steps = [].slice.call(story.querySelectorAll('[data-story-step]'));
    var pics = [].slice.call(story.querySelectorAll('[data-story-pic]'));
    if (!steps.length) return;
    var cur = -1;
    function set(i) {
      if (i === cur) return;
      cur = i;
      steps.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      pics.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
    }
    function tick() {
      var mid = window.innerHeight * 0.5, best = 0, bd = Infinity;
      steps.forEach(function (s, k) {
        var r = s.getBoundingClientRect();
        var d = Math.abs((r.top + r.bottom) / 2 - mid);
        if (d < bd) { bd = d; best = k; }
      });
      set(best);
    }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    story.__tick = tick;
    tick();
  });

  /* 5b. the ingredient strip: one copy is written by the server, the second
     copy (for a seamless loop) is added here and hidden from screen readers */
  document.querySelectorAll('[data-marquee]').forEach(function (m) {
    var track_ = m.querySelector('.mq-track');
    if (!track_ || track_.getAttribute('data-doubled')) return;
    var copy = track_.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
    track_.setAttribute('data-doubled', '1');
    m.querySelector('.mq-rail').appendChild(copy);
  });

  /* 5c. numbers count up once when they come into view: the founder and
     laboratory facts. Only plain numbers; "Ph.D." and "20+" keep their text. */
  if (!CALM && 'IntersectionObserver' in window) {
    var facts = document.querySelectorAll('.fs-facts b, .lab-facts b');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (x) {
        if (!x.isIntersecting) return;
        io.unobserve(x.target);
        var el = x.target, m = /^(\d+)(\+?)$/.exec(el.textContent.trim());
        if (!m) return;
        var end = +m[1], suf = m[2], t0 = performance.now(), dur = 900;
        (function step(now) {
          var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(end * e) + suf;
          if (k < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.6 });
    facts.forEach(function (f) { if (/^\d+\+?$/.test(f.textContent.trim())) io.observe(f); });
  }

  /* 5d. product page: "on this page" rail beside the details, the current
     section marked as you read */
  (function () {
    var info = document.querySelector('.product-info');
    if (!info) return;
    var targets = [
      ['How to use', '.howto, .pdetails'], ['What is inside', '.inside'], ['Who it suits', '.suits'],
      ['Questions', '.pfaq'], ['Pairs well with', '.together']
    ].map(function (t) { return [t[0], document.querySelector(t[1])]; }).filter(function (t) { return t[1]; })
      .sort(function (a, b) { return a[1].compareDocumentPosition(b[1]) & 4 ? -1 : 1; });
    if (targets.length < 3) return;
    var rail = document.createElement('nav');
    rail.className = 'onpage';
    rail.setAttribute('aria-label', T('On this page'));
    rail.innerHTML = targets.map(function (t, i) {
      if (!t[1].id) t[1].id = 'onpage-' + i;
      return '<a href="#' + t[1].id + '">' + esc(T(t[0])) + '</a>';
    }).join('');
    var anchor = info.querySelector('.pactions') || info.querySelector('.buybox');
    if (!anchor) return;
    anchor.insertAdjacentElement('afterend', rail);
    var links = [].slice.call(rail.querySelectorAll('a'));
    function mark() {
      var line = window.innerHeight * 0.35, cur = -1;
      targets.forEach(function (t, i) { if (t[1].getBoundingClientRect().top < line) cur = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === cur); });
    }
    window.addEventListener('scroll', mark, { passive: true });
    mark();
  })();

  /* 5e. add to cart answers: the button turns into a tick, the cart count pops */
  var lastAddBtn = null, lastAddAt = 0, lastCount = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-add-to-cart], [data-add-lines], [data-quick-add], .quick, .gcard-add, [data-adv-add], [data-buybar-submit]');
    if (b) { lastAddBtn = b; lastAddAt = Date.now(); }
  }, true);
  function countNow() {
    var el = document.querySelector('[data-cart-count]');
    return el ? parseInt(el.textContent, 10) || 0 : 0;
  }
  lastCount = countNow();
  var countObs = new MutationObserver(function () {
    var n = countNow();
    if (lastCount !== null && n > lastCount) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });
      if (lastAddBtn && Date.now() - lastAddAt < 4000) {
        var b = lastAddBtn;
        b.classList.add('is-added');
        setTimeout(function () { b.classList.remove('is-added'); }, 1400);
        lastAddBtn = null;
      }
      track('add_to_cart', { count: n });
    }
    lastCount = n;
  });
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    countObs.observe(el, { childList: true, characterData: true, subtree: true });
  });

  /* 5f. the picture you tapped becomes the product page's picture: each card
     image gets a transition name just before the page changes */
  if (!CALM && 'CSS' in window && CSS.supports && CSS.supports('view-transition-name: a')) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.card, a.fcard, a.big, .fcard a, .card a');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var img = a.querySelector('img');
      if (img) img.style.viewTransitionName = 'product-shot';
    }, true);
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('img[style*="view-transition-name"]').forEach(function (i) { i.style.viewTransitionName = ''; });
    });
  }

  /* ══ 6. TECHNICAL ══════════════════════════════════════════════════════════ */

  /* 6a. offline: say so calmly, and keep add-to-cart from failing silently */
  (function () {
    var bar;
    function set(off) {
      if (off && !bar) {
        bar = document.createElement('div');
        bar.className = 'offline';
        bar.setAttribute('role', 'status');
        bar.textContent = T('You are offline. The page stays open; ordering works again when you reconnect.');
        document.body.appendChild(bar);
      }
      if (bar) bar.classList.toggle('is-on', off);
      document.documentElement.classList.toggle('is-offline', off);
      if (!off && window.GloramousCart) window.GloramousCart.refresh();
    }
    window.addEventListener('offline', function () { set(true); });
    window.addEventListener('online', function () { set(false); });
    if (navigator.onLine === false) set(true);
  })();

  /* 6b. delivery details for WhatsApp orders: name, area, address, phone,
     remembered in this browser and written into the order message */
  var AREAS = ['Beirut', 'Achrafieh', 'Hamra', 'Verdun', 'Mar Mikhael', 'Badaro', 'Dekwaneh', 'Sin El Fil', 'Jdeideh', 'Zalka',
    'Jal El Dib', 'Antelias', 'Dbayeh', 'Jounieh', 'Kaslik', 'Byblos (Jbeil)', 'Batroun', 'Tripoli', 'Zgharta', 'Koura', 'Akkar',
    'Baabda', 'Hazmieh', 'Hadath', 'Aley', 'Bhamdoun', 'Chouf', 'Damour', 'Saida', 'Jezzine', 'Tyre (Sour)', 'Nabatieh',
    'Marjayoun', 'Bint Jbeil', 'Hasbaya', 'Zahle', 'Chtaura', 'Baalbek', 'Hermel', 'West Bekaa', 'Broummana', 'Bikfaya', 'Metn'];
  var DKEY = 'gloramous.delivery';
  window.GloramousDelivery = function () {
    try { return JSON.parse(localStorage.getItem(DKEY) || '{}') || {}; } catch (e) { return {}; }
  };
  function deliveryForm() {
    var d = window.GloramousDelivery();
    var box = document.createElement('details');
    box.className = 'wa-details';
    if (d.name || d.area) box.open = false;
    box.innerHTML = '<summary>' + esc(T('Delivery details for WhatsApp')) + '</summary>' +
      '<div class="wa-fields">' +
      '<label><span>' + esc(T('Your name')) + '</span><input form="gl-wa-none" name="name" autocomplete="name" value="' + esc(d.name || '') + '"></label>' +
      '<label><span>' + esc(T('Area')) + '</span><input form="gl-wa-none" name="area" list="lb-areas" autocomplete="address-level2" value="' + esc(d.area || '') + '"></label>' +
      '<label class="wa-wide"><span>' + esc(T('Street, building, floor')) + '</span><input form="gl-wa-none" name="address" autocomplete="street-address" value="' + esc(d.address || '') + '"></label>' +
      '<label><span>' + esc(T('Phone')) + '</span><input form="gl-wa-none" name="phone" type="tel" autocomplete="tel" value="' + esc(d.phone || '') + '"></label>' +
      '</div><p class="wa-eta" data-wa-eta hidden></p>' +
      '<p class="wa-hint">' + esc(T('Saved in this browser only, and added to your WhatsApp message.')) + '</p>';
    function eta() {
      var el = box.querySelector('[data-wa-eta]');
      var area = (box.querySelector('input[name="area"]').value || '').trim().toLowerCase();
      if (!el) return;
      if (!area) { el.hidden = true; return; }
      var fee = parseInt(document.body.getAttribute('data-delivery-fee') || '0', 10) || 0;
      // no delivery-time promise (removed 2026-09-24): just the flat fee
      if (!fee) { el.hidden = true; return; }
      el.textContent = T('Delivery to your area') + ': $' + (fee / 100).toFixed(2);
      el.hidden = false;
    }
    setTimeout(eta, 0);
    box.addEventListener('input', eta);
    /* On the cart page this box sits inside <form data-cart-form>, whose
       default button is Checkout: Enter (Go on a phone keyboard) in any field
       sent the shopper to Shopify checkout instead of WhatsApp, and the fields
       rode along on every quantity change. form="gl-wa-none" points at no
       form, so the inputs have no owner; the keydown guard is the backstop. */
    box.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName === 'INPUT') e.preventDefault(); });
    box.addEventListener('input', function () {
      var v = {};
      box.querySelectorAll('input').forEach(function (i) { v[i.name] = i.value.trim(); });
      try { localStorage.setItem(DKEY, JSON.stringify(v)); } catch (e) {}
      clearTimeout(box._t);
      box._t = setTimeout(function () { if (window.GloramousWaRefresh) window.GloramousWaRefresh(); }, 250);
    });
    return box;
  }
  if (!document.getElementById('lb-areas')) {
    var dl = document.createElement('datalist');
    dl.id = 'lb-areas';
    dl.innerHTML = AREAS.map(function (a) { return '<option value="' + esc(a) + '">'; }).join('');
    document.body.appendChild(dl);
  }
  function placeDelivery() {
    document.querySelectorAll('[data-wa-order]').forEach(function (a) {
      if (a.closest('.tabbar, .wa-float, .np-wa, .site-foot')) return;
      var host = a.parentElement;
      if (!host || host.querySelector('.wa-details')) return;
      host.insertBefore(deliveryForm(), a);
    });
    document.querySelectorAll('input[name="contact[City]"]').forEach(function (i) { i.setAttribute('list', 'lb-areas'); });
  }
  placeDelivery();
  new MutationObserver(function () { clearTimeout(placeDelivery._t); placeDelivery._t = setTimeout(placeDelivery, 60); })
    .observe(document.body, { childList: true, subtree: true });

  /* 6c. events on the moments that matter */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="wa.me/"]');
    if (a) track('whatsapp_click', { order: a.hasAttribute('data-wa-order'), page: location.pathname });
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.matches && e.target.matches('[data-pro]')) track('pro_request', {});
  }, true);
})();

/* A variant with no price cannot be added to a cart: when the shopper switches
   to one, both Add to cart buttons turn into "Price on request" and go dead.
   (2026-09-22, found on the live store: the buttons stayed live on $0 variants.) */
(function () {
  'use strict';
  var box = document.querySelector('[data-opts]');
  if (!box) return;
  var T = function (s) { return window.GloramousT ? (window.GloramousT(s) || s) : s; };
  function sync() {
    var on = box.querySelector('[aria-pressed="true"]');
    if (!on) return;
    var free = parseInt(on.getAttribute('data-price-cents'), 10) === 0;
    document.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      if (free) {
        if (!b.hasAttribute('data-buy-label')) b.setAttribute('data-buy-label', b.textContent.trim());
        b.disabled = true;
        b.textContent = T('Price on request');
      } else if (b.hasAttribute('data-buy-label')) {
        b.disabled = false;
        b.textContent = b.getAttribute('data-buy-label');
        b.removeAttribute('data-buy-label');
      }
    });
  }
  box.addEventListener('click', function () { setTimeout(sync, 0); });
  sync();
})();

/* ══ FROM THE LAB: THE POSTER WHEEL (2026-09-24) ═══════════════════════════
   The user asked for the posters to loop like a wheel with no scrollbar. The
   row is cloned until it covers the screen twice over, and a position in
   pixels is wrapped by the width of one set, so it has no end either way.
   It drifts at 28px a second while at least part of it is on screen; the
   pointer resting on it, a keyboard focus inside it, a drag, or an arrow
   press stops it, and it picks up again 2.5s after a drag or an arrow.
   Dragging with a mouse or a finger moves it by hand (vertical swipes still
   scroll the page). "Reduce motion": no drift, and arrow steps jump. */
(function () {
  'use strict';
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-wheel]').forEach(function (wheel) {
    var track = wheel.querySelector('[data-wheel-track]');
    var section = wheel.closest('.posters') || wheel.parentNode;
    if (!track) return;
    var rtl = document.documentElement.dir === 'rtl' || getComputedStyle(section).direction === 'rtl';
    var originals = Array.prototype.slice.call(track.children);
    /* the track runs left to right in both languages; in Arabic the posters are
       put in reverse so they still read from the right */
    if (rtl) { originals.reverse(); originals.forEach(function (li) { track.appendChild(li); }); }
    var shown = originals.filter(function (li) { return li.offsetWidth > 0; });
    if (shown.length < 2) return;
    var SPEED = 28, IDLE = 2500;
    var pos = 0, W = 0, step = 0, last = 0;
    var seen = true, hover = false, focused = false, dragging = false, holdUntil = 0, tween = null;
    /* a visible pause: on a phone there is no hover to hold it still */
    var userStopped = false;
    if (!calm.matches) {
      var pb = document.createElement('button');
      pb.type = 'button'; pb.className = 'motion-pause';
      pb.setAttribute('aria-pressed', 'false');
      pb.setAttribute('aria-label', 'Pause the moving strip');
      pb.innerHTML = '<svg class="mp-pause" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg><svg class="mp-play" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><path d="M8 5.2v13.6L19 12z"/></svg>';
      pb.addEventListener('click', function () {
        userStopped = !userStopped;
        pb.setAttribute('aria-pressed', userStopped ? 'true' : 'false');
        pb.setAttribute('aria-label', userStopped ? 'Play the moving strip' : 'Pause the moving strip');
        pb.classList.toggle('is-stopped', userStopped);
      });
      wheel.parentNode.insertBefore(pb, wheel.nextSibling);
    }

    function cloneSet() {
      originals.forEach(function (li) {
        var c = li.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = -1; });
        track.appendChild(c);
      });
    }
    function measure() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      W = 0;
      shown.forEach(function (li) { W += li.getBoundingClientRect().width + gap; });
      step = shown[0].getBoundingClientRect().width + gap;
      while (track.scrollWidth < W + wheel.clientWidth * 2) cloneSet();
      wrap();
    }
    function wrap() {
      if (!W) return;
      while (pos <= -W) pos += W;
      while (pos > 0) pos -= W;
    }
    function paint() { track.style.transform = 'translate3d(' + pos.toFixed(2) + 'px,0,0)'; }
    function moving() {
      return !calm.matches && !userStopped && seen && !hover && !focused && !dragging && !tween &&
             document.visibilityState !== 'hidden' && performance.now() > holdUntil;
    }
    function frame(now) {
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 0;
      last = now;
      if (tween) {
        var k = Math.min(1, (now - tween.t0) / tween.dur), e = 1 - Math.pow(1 - k, 3);
        tween.cur = tween.from + (tween.to - tween.from) * e;
        pos = tween.cur;
        if (k >= 1) { tween = null; holdUntil = now + IDLE; }
        wrap(); paint();
      } else if (moving()) {
        pos += (rtl ? SPEED : -SPEED) * dt;
        wrap(); paint();
      }
      requestAnimationFrame(frame);
    }

    /* the pointer resting on it holds it still (mouse only: a finger has no hover) */
    wheel.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    wheel.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') hover = false; });

    /* drag or swipe by hand */
    var sx = 0, sy = 0, spos = 0, down = false, moved = false, pid = null;
    wheel.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sy = e.clientY; spos = pos; pid = e.pointerId; tween = null;
    });
    wheel.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!moved) {
        if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(dy)) return;
        moved = true; dragging = true; wheel.classList.add('is-dragging');
        try { wheel.setPointerCapture(pid); } catch (err) {}
      }
      pos = spos + dx; wrap(); paint();
    });
    function release() {
      if (!down) return;
      down = false;
      if (dragging) { dragging = false; wheel.classList.remove('is-dragging'); holdUntil = performance.now() + IDLE; }
    }
    wheel.addEventListener('pointerup', release);
    wheel.addEventListener('pointercancel', release);
    /* a drag must not open the poster it ended on */
    wheel.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    wheel.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* a sideways trackpad swipe moves it too */
    wheel.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault(); tween = null;
      pos -= e.deltaX; wrap(); paint();
      holdUntil = performance.now() + IDLE;
    }, { passive: false });

    /* the arrows: one poster at a time */
    section.querySelectorAll('[data-wheel-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = +b.getAttribute('data-wheel-step') * (rtl ? -1 : 1);
        /* a press during a step carries on from where that step was going */
        var to = pos + (tween ? tween.to - tween.cur : 0) - dir * step;
        if (calm.matches) { tween = null; pos = to; wrap(); paint(); holdUntil = performance.now() + IDLE; return; }
        tween = { from: pos, cur: pos, to: to, t0: performance.now(), dur: 450 };
      });
    });

    /* keyboard: a focused poster stops the wheel and is brought fully into view */
    wheel.addEventListener('focusin', function (e) {
      focused = true;
      var li = e.target.closest('.poster');
      if (!li) return;
      var box = wheel.getBoundingClientRect(), r = li.getBoundingClientRect(), pad = 24;
      if (r.left < box.left + pad) pos += (box.left + pad) - r.left;
      else if (r.right > box.right - pad) pos -= r.right - (box.right - pad);
      wheel.scrollLeft = 0; wrap(); paint();
    });
    wheel.addEventListener('focusout', function (e) {
      if (!wheel.contains(e.relatedTarget)) focused = false;
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; }, { rootMargin: '100px 0px' }).observe(wheel);
    }
    wheel.classList.add('is-on');
    measure();
    /* the first poster starts in line with the page's text column: at the left
       edge in English, the right edge in Arabic */
    var pad = Math.max(16, (wheel.clientWidth - 1220) / 2 + 24);
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    pos = rtl ? wheel.clientWidth - pad - (W - gap) : pad;
    wrap(); paint();
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(measure, 150); });
    wheel._wheel = { get pos() { return pos; }, get W() { return W; }, get step() { return step; } };
    requestAnimationFrame(frame);
  });
})();

/* The sets on the homepage: a swipe rail on phones, with page dots that follow
   the swipe and jump to a set when tapped. CSS does the snapping; this only
   writes --snap (opacity emphasis) and keeps the dots in step. RTL-safe:
   scrollLeft runs negative in Arabic, so distances are taken as absolutes. */
(function () {
  'use strict';
  var T = function (s) { return window.GloramousT ? (window.GloramousT(s) || s) : s; };
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var phone = window.matchMedia('(max-width:759px)');
  document.querySelectorAll('.offers-grid').forEach(function (rail) {
    var kids = [].slice.call(rail.children);
    if (kids.length < 2) return;
    var rtl = getComputedStyle(rail).direction === 'rtl';
    var name = (rail.closest('section') && rail.closest('section').querySelector('h2')) ;
    rail.setAttribute('role', 'region');
    rail.setAttribute('aria-label', name ? name.textContent.trim() : T('Sets'));
    var dots = document.createElement('div');
    dots.className = 'offers-dots';
    dots.innerHTML = kids.map(function (k, i) {
      var t = k.querySelector('b');
      return '<button type="button" aria-label="' + (t ? t.textContent.replace(/"/g, '&quot;') : String(i + 1)) + '"></button>';
    }).join('');
    rail.parentNode.insertBefore(dots, rail.nextSibling);
    var btns = [].slice.call(dots.children);
    var offs = [], span = 1;
    function measure() {
      var base = kids[0].offsetLeft;
      offs = kids.map(function (k) { return Math.abs(k.offsetLeft - base); });
      span = offs[1] || kids[0].offsetWidth || 1;
    }
    function paint() {
      var x = Math.abs(rail.scrollLeft), lead = 0, best = Infinity;
      /* at the far end the last set cannot reach the leading edge: count it as current */
      var end = rail.scrollWidth - rail.clientWidth - x < 2;
      kids.forEach(function (k, i) {
        var d = Math.abs(offs[i] - x);
        k.style.setProperty('--snap', Math.max(0, 1 - d / span).toFixed(3));
        if (d < best) { best = d; lead = i; }
      });
      if (end) { lead = kids.length - 1; kids[lead].style.setProperty('--snap', '1'); }
      btns.forEach(function (b, i) { b.setAttribute('aria-current', String(i === lead)); });
    }
    function sync() {
      if (phone.matches) { rail.classList.add('is-rail'); rail.tabIndex = 0; measure(); paint(); }
      else { rail.classList.remove('is-rail'); rail.removeAttribute('tabindex'); kids.forEach(function (k) { k.style.removeProperty('--snap'); }); }
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        measure();
        rail.scrollTo({ left: rtl ? -offs[i] : offs[i], behavior: CALM ? 'auto' : 'smooth' });
      });
    });
    rail.addEventListener('scroll', paint, { passive: true });
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
    sync();
  });
})();

/* ══════════════════════════════════════════════════════════════════════════
   ORDER FORM: "Use my location" (owner, 2026-10-01)
   The cash-on-delivery form (EasySell app, #es-form) asks for an address and
   a region. One tap fills both from the phone's location, and the address
   gets " / " plus a Google Maps link so the courier can open the exact spot.
   The app draws the form, so the button is added (and re-added) from here.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (!('geolocation' in navigator)) return;
  var LABEL = 'Use my location / استخدم موقعي';
  var BUSY = 'Finding you… / جارٍ تحديد موقعك…';
  var DENIED = 'Location is off. Please type your address / الموقع غير مفعّل، اكتب عنوانك';
  var DONE = 'Location added / تمت إضافة الموقع';
  var MAP_RE = /\s*\/\s*https:\/\/maps\.google\.com\/\?q=\S+$/;
  // governorate names as the map service writes them -> the form's region codes
  // (English or French, as the lookup services write them: Mont-Liban, Liban-Nord, Beyrouth...)
  var REGIONS = [
    [/akkar|aakar/i, 'LB_AK'], [/baalbek|balabak|hermel|hirmil/i, 'LB_BH'], [/beirut|beyrouth|bayrut/i, 'LB_BA'],
    [/beqaa|bekaa|biqa/i, 'LB_BI'], [/mount lebanon|mont.liban|jabal lubnan|keserwan|kesrouan|jbeil|byblos/i, 'LB_JL'],
    [/nabat/i, 'LB_NA'], [/north|nord|shimal|shamal/i, 'LB_AS'], [/south|sud|janub|janoub|jnoub/i, 'LB_JA']
  ];

  function setVal(el, v) {
    var proto = el.tagName === 'SELECT' ? HTMLSelectElement.prototype : HTMLInputElement.prototype;
    var desc = Object.getOwnPropertyDescriptor(proto, 'value');
    if (desc && desc.set) desc.set.call(el, v); else el.value = v;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // a free lookup made for browsers; OpenStreetMap as a second try. Either way
  // the answer is { place: 'street, area, town', region: 'governorate' }
  function getJSON(url) {
    /* 8 s at most: a lookup service that hangs must not leave the button
       stuck on "Finding you…" */
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 8000) : null;
    return fetch(url, { headers: { 'Accept': 'application/json' }, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (x) { if (timer) clearTimeout(timer); return x; });
  }
  function uniq(list) { return list.filter(function (x, i, a) { return x && a.indexOf(x) === i; }); }
  function lookup(lat, lng) {
    return getJSON('https://api.bigdatacloud.net/data/reverse-geocode-client?localityLanguage=en&latitude=' + lat + '&longitude=' + lng)
      .then(function (j) {
        if (j && (j.locality || j.city)) {
          var adm = ((j.localityInfo && j.localityInfo.administrative) || []).map(function (x) { return x.name; });
          return { place: uniq([j.locality, j.city]).join(', '), sub: j.principalSubdivision || '', region: [j.principalSubdivision].concat(adm).join(' ') };
        }
        return getJSON('https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=18&addressdetails=1&accept-language=en&lat=' + lat + '&lon=' + lng)
          .then(function (g) {
            var a = (g && g.address) || {};
            return { place: uniq([a.road, a.neighbourhood || a.suburb || a.quarter || a.hamlet,
              a.village || a.town || a.city || a.municipality]).join(', ') || (g && g.name) || '',
              sub: a.state || '', region: [a.state, a.province, a.county, a.region].filter(Boolean).join(' ') };
          });
      });
  }

  function fill(form, btn) {
    var addr = form.querySelector('input[name="address"]');
    var region = form.querySelector('select[name="city"]');
    if (!addr) return;
    btn.disabled = true;
    btn.querySelector('span').textContent = BUSY;
    navigator.geolocation.getCurrentPosition(function (pos) {
      var lat = pos.coords.latitude.toFixed(6), lng = pos.coords.longitude.toFixed(6);
      var link = 'https://maps.google.com/?q=' + lat + ',' + lng;
      lookup(lat, lng).then(function (geo) {
        geo = geo || { place: '', region: '' };
        // the address is always "place name / map link"; what the customer typed is kept in front
        var typed = addr.value.replace(MAP_RE, '').trim();
        // a second press replaces what the first one wrote; only the customer's own words stay
        if (typed && typed === addr.getAttribute('data-loc-name')) typed = '';
        var name = uniq([typed, geo.place]).join(', ') || 'My location';
        setVal(addr, name + ' / ' + link);
        addr.setAttribute('data-loc-name', name);
        if (region) {
          // the governorate decides; district names only if it is missing
          // ("Bint Jbeil District" is in Nabatieh, not Mount Lebanon)
          var clean = function (s) { return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, ''); };
          var pick = function (txt) {
            for (var i = 0; i < REGIONS.length; i++) { if (REGIONS[i][0].test(txt)) return REGIONS[i][1]; }
            return '';
          };
          var code = pick(clean(geo.sub)) || pick(clean(geo.region));
          if (code) setVal(region, code);
        }
        btn.disabled = false;
        btn.classList.add('is-done');
        btn.querySelector('span').textContent = DONE;
      });
    }, function () {
      btn.disabled = false;
      btn.querySelector('span').textContent = DENIED;
      addr.focus();
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
  }

  function add(form) {
    if (form.querySelector('.es-loc')) return;
    var group = form.querySelector('.es-address-group');
    if (!group) return;
    var row = document.createElement('div');
    row.className = 'es-group es-loc';
    row.innerHTML = '<div class="row"><div class="es-label-column"></div><div class="es-input-column">' +
      '<button type="button" class="es-loc-btn"><svg class="es-loc-pin" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">' +
      '<path d="M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z"/></svg>' +
      '<span>' + LABEL + '</span></button>' +
      '</div></div>';
    group.parentNode.insertBefore(row, group.nextSibling);   // between Address and Region
    row.querySelector('button').addEventListener('click', function () { fill(form, this); });
  }

  function scan() { document.querySelectorAll('#es-form, form.es-form').forEach(add); }
  scan();
  // the app draws (and redraws) its form after load and when the popup opens
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
